var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-403-error-forbidden",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-403-error-forbidden:not(.animated) .animable {opacity:\r\n        0;}svg#freepik_stories-403-error-forbidden.animated #freepik--Floor--inject-32 {animation: 1s 1 forwards\r\n        cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-403-error-forbidden.animated\r\n        #freepik--Shadows--inject-32 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38)\r\n        slideRight;animation-delay: 0s;}svg#freepik_stories-403-error-forbidden.animated #freepik--Door--inject-32\r\n        {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay:\r\n        0s;}svg#freepik_stories-403-error-forbidden.animated #freepik--error-403--inject-32 {animation: 1s 1 forwards\r\n        cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-403-error-forbidden.animated\r\n        #freepik--Character--inject-32 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay:\r\n        0s;}svg#freepik_stories-403-error-forbidden.animated #freepik--speech-bubble--inject-32 {animation: 1s 1\r\n        forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay:\r\n        0s;}svg#freepik_stories-403-error-forbidden.animated #freepik--Plant--inject-32 {animation: 1s 1 forwards\r\n        cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;} @keyframes fadeIn { 0% { opacity: 0; } 100%\r\n        { opacity: 1; } } @keyframes slideRight { 0% { opacity: 0; transform: translateX(30px); } 100% { opacity: 1;\r\n        transform: translateX(0); } } @keyframes slideUp { 0% { opacity: 0; transform: translateY(30px); } 100% {\r\n        opacity: 1; transform: inherit; } } @keyframes zoomOut { 0% { opacity: 0; transform: scale(1.5); } 100% {\r\n        opacity: 1; transform: scale(1); } } @keyframes zoomIn { 0% { opacity: 0; transform: scale(0.5); } 100% {\r\n        opacity: 1; transform: scale(1); } } @keyframes lightSpeedLeft { from { transform: translate3d(-50%, 0, 0)\r\n        skewX(20deg); opacity: 0; } 60% { transform: skewX(-10deg); opacity: 1; } 80% { transform: skewX(2deg); } to {\r\n        opacity: 1; transform: translate3d(0, 0, 0); } }\r\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-32",
    className: "animable",
    style: {
      transformOrigin: "250px 384.61px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-32",
    cx: 250,
    cy: 384.61,
    rx: 209.73,
    ry: 94.79,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 384.61px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-32",
    className: "animable",
    style: {
      transformOrigin: "246.486px 400.105px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-32",
    cx: 352.36,
    cy: 395.73,
    rx: 56.05,
    ry: 32.36,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "352.36px 395.73px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-32",
    d: "M91.71,412.52c-9.53,5.57-9.53,14.59,0,20.15s25,5.56,34.51,0,9.53-14.58,0-20.15S101.24,407,91.71,412.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "108.961px 422.601px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-32",
    className: "animable",
    style: {
      transformOrigin: "169.765px 254.323px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bricks--inject-32",
    className: "animable",
    style: {
      transformOrigin: "169.765px 221.269px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.87,225.91v3.46c0,1.09.77,1.53,1.71,1l3.34-1.92V221L105.58,223A3.78,3.78,0,0,0,103.87,225.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "106.395px 225.797px"
    },
    id: "elsa8o01eczkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.28,223v3.45c0,1.09.77,1.53,1.71,1l13.93-8V212L95,220A3.78,3.78,0,0,0,93.28,223Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "101.1px 219.837px"
    },
    id: "eligr3ylotj9k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,262.05,85,271.18a3.8,3.8,0,0,0-1.71,3v3.46c0,1.09.77,1.53,1.71,1l15.82-9.13a3.78,3.78,0,0,0,1.71-3V263C102.53,261.94,101.76,261.5,100.82,262.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "92.91px 270.338px"
    },
    id: "el5ppv6jkwf8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.92,302.88l-13.93,8a3.78,3.78,0,0,0-1.71,3v3.46c0,1.09.77,1.53,1.71,1l13.93-8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "101.1px 310.722px"
    },
    id: "eld6lgbmbukk5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.28,186.59V190c0,1.09.77,1.53,1.71,1l13.93-8v-7.4l-13.93,8A3.78,3.78,0,0,0,93.28,186.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "101.1px 183.412px"
    },
    id: "el6bsjfw1rtx2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.44,295.91v3.46c0,1.09.76,1.53,1.71,1L95,291.23a3.77,3.77,0,0,0,1.71-3v-3.46c0-1.09-.76-1.53-1.71-1L79.15,293A3.77,3.77,0,0,0,77.44,295.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.075px 292.07px"
    },
    id: "elqcgfcd09wv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.28,259.32v3.46c0,1.09.77,1.53,1.71,1l13.93-8v-7.41L95,256.37A3.78,3.78,0,0,0,93.28,259.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "101.1px 256.187px"
    },
    id: "el33ddaoazv7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.94,318.09v-3.45c0-1.09-.76-1.54-1.71-1l-15.82,9.13a3.8,3.8,0,0,0-1.71,3v3.46c0,1.09.77,1.53,1.71,1l15.82-9.14A3.75,3.75,0,0,0,91.94,318.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "82.32px 321.933px"
    },
    id: "elbljebqdx98n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,176.33,76.2,185.46a3.8,3.8,0,0,0-1.71,3v3.46c0,1.09.77,1.53,1.71,1L92,183.74a3.8,3.8,0,0,0,1.71-3v-3.46C93.73,176.23,93,175.79,92,176.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "84.1002px 184.621px"
    },
    id: "elos1hbcpz2w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,189.31,85,198.44a3.8,3.8,0,0,0-1.71,3v3.46c0,1.09.77,1.53,1.71,1l15.82-9.14a3.78,3.78,0,0,0,1.71-3v-3.46C102.53,189.2,101.76,188.76,100.82,189.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "92.91px 197.599px"
    },
    id: "elyy3q85qnnr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,225.68,85,234.81a3.8,3.8,0,0,0-1.71,3v3.46c0,1.09.77,1.53,1.71,1l15.82-9.13a3.78,3.78,0,0,0,1.71-3v-3.46C102.53,225.57,101.76,225.13,100.82,225.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "92.91px 233.969px"
    },
    id: "el1nsw9n8gaxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,333.14,100.82,324a3.8,3.8,0,0,0,1.71-3v-3.46c0-1.09-.77-1.53-1.71-1L85,325.73a3.8,3.8,0,0,0-1.71,3v3.46C83.29,333.24,84.06,333.68,85,333.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "92.91px 324.844px"
    },
    id: "elyrys8k7a6om",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.65,161.92v3.46a3.77,3.77,0,0,1-1.7,3l-3.34,1.93v-7.41l3.34-1.92C234.89,160.39,235.65,160.83,235.65,161.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.13px 165.513px"
    },
    id: "elr3i7kksjwks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.61,281.09l13.93-8c.94-.55,1.7-.1,1.7,1v3.45a3.77,3.77,0,0,1-1.7,3l-13.93,8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "238.425px 280.698px"
    },
    id: "elfe77czkboh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.24,146.74v3.46a3.79,3.79,0,0,1-1.7,3l-13.93,8v-7.4l13.93-8C245.48,145.21,246.24,145.65,246.24,146.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "238.425px 153.368px"
    },
    id: "elvzfpjr6jmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.71,194.54l15.82-9.14c.94-.54,1.71-.1,1.71,1v3.46a3.8,3.8,0,0,1-1.71,3l-15.82,9.13c-1,.55-1.71.1-1.71-1V197.5A3.75,3.75,0,0,1,238.71,194.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "246.62px 193.697px"
    },
    id: "elve5x21nugug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.61,244.72l13.93-8c.94-.54,1.7-.1,1.7,1v3.45a3.77,3.77,0,0,1-1.7,3l-13.93,8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "238.425px 244.33px"
    },
    id: "elxgjd9rgzee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.24,110.37v3.46a3.77,3.77,0,0,1-1.7,3l-13.93,8v-7.4l13.93-8C245.48,108.84,246.24,109.28,246.24,110.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "238.425px 116.998px"
    },
    id: "el3fvf3nqz3vo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.09,201.4v3.46a3.77,3.77,0,0,1-1.71,3L244.56,217c-.94.55-1.7.11-1.7-1v-3.46a3.77,3.77,0,0,1,1.7-3l15.82-9.13C261.33,199.87,262.09,200.31,262.09,201.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "252.475px 208.708px"
    },
    id: "elzq8o56cz5se",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.24,183.11v3.46a3.79,3.79,0,0,1-1.7,3l-13.93,8v-7.4l13.93-8C245.48,181.58,246.24,182,246.24,183.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "238.425px 189.736px"
    },
    id: "el8nj2cd4bvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59,240.33v-3.46a3.77,3.77,0,0,1,1.71-3l15.82-9.13c.94-.55,1.71-.11,1.71,1v3.46a3.78,3.78,0,0,1-1.71,3l-15.82,9.14C248.35,241.86,247.59,241.42,247.59,240.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "257.21px 233.031px"
    },
    id: "el1x2apoxkw0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.71,121.8l15.82-9.14c.94-.54,1.71-.1,1.71,1v3.46a3.8,3.8,0,0,1-1.71,3l-15.82,9.13c-1,.55-1.71.1-1.71-1v-3.46A3.75,3.75,0,0,1,238.71,121.8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "246.62px 120.957px"
    },
    id: "elzkttzf7sfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.71,158.17,254.53,149c.94-.54,1.71-.1,1.71,1v3.46a3.8,3.8,0,0,1-1.71,3l-15.82,9.13c-1,.55-1.71.1-1.71-1v-3.45A3.75,3.75,0,0,1,238.71,158.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "246.62px 157.297px"
    },
    id: "elkecv3v0t7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.53,247.36l-15.82,9.14c-1,.54-1.71.1-1.71-1v-3.46a3.77,3.77,0,0,1,1.71-3L254.53,240c.94-.55,1.71-.1,1.71,1v3.46A3.78,3.78,0,0,1,254.53,247.36Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "246.62px 248.248px"
    },
    id: "elkkg44r2oss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.61,299.27l13.93-8c.94-.54,1.7-.1,1.7,1v3.46a3.79,3.79,0,0,1-1.7,3l-13.93,8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "238.425px 298.885px"
    },
    id: "elzr8z08cihc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-32",
    className: "animable",
    style: {
      transformOrigin: "169.771px 254.323px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-32",
    className: "animable",
    style: {
      transformOrigin: "169.771px 254.323px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.92,413V165.44a12,12,0,0,1,5.42-9.38L221.46,94.21a3.83,3.83,0,0,1,3.83-.38L229,96a3.79,3.79,0,0,1,1.6,3.51V347.06l-7.81,4.51-6.34-3.67-96,55.42v7.33l-7.81,4.51Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "169.771px 254.323px"
    },
    id: "el3cxkv8h96ku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.28,395.32l-13.85,8v7.33l-7.81,4.51-3.7-2.14V165.44a11,11,0,0,1,1.6-5.35l23.58,13.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.6px 287.625px"
    },
    id: "elop2z1vkzfb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.62,167.59V415.14l7.81-4.5v-7.32l96-55.42,6.34,3.66,7.81-4.5V99.48c0-3.47-2.43-4.85-5.4-3.13L118,158.21A12,12,0,0,0,112.62,167.59Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "171.6px 255.376px"
    },
    id: "el4owvfaho637",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.43 168.9 120.43 406.38 219.1 349.42 219.1 111.95 120.43 168.9",
    style: {
      fill: "current",
      transformOrigin: "169.765px 259.165px"
    },
    id: "elblpo5l2ewj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2k6ofcz9rzq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "120.43 168.9 120.43 406.38 219.1 349.42 219.1 111.95 120.43 168.9",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "169.765px 259.165px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8swr4uj5qqb"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.43,
      transformOrigin: "169.75px 259.165px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.25,377.26V178.61l65-37.54V339.71ZM140,180.19V372.53l59.59-34.4V145.8Z",
    style: {
      fill: "current",
      transformOrigin: "169.75px 259.165px"
    },
    id: "eljs85ludvisl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elut69zs1d8il"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.25,178.61V377.26l65-37.55V141.07Zm62.31,159.52L140,372.53V180.19l59.59-34.39Z",
    style: {
      opacity: 0.1,
      transformOrigin: "169.75px 259.165px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "219.1 349.42 219.1 111.95 222.75 109.83 222.76 351.57 219.1 349.42",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.93px 230.7px"
    },
    id: "eluj0tdtrdce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.43 410.64 222.76 351.57 219.1 349.42 120.43 406.38 120.43 410.64",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.595px 380.03px"
    },
    id: "eldiijmo05wof",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Latch--inject-32",
    className: "animable",
    style: {
      transformOrigin: "137.245px 271.895px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "122.34 258.22 124.31 259.36 124.32 292.09 122.34 290.95 122.34 258.22",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "123.33px 275.155px"
    },
    id: "elivl20n704l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.31 259.36 134.94 253.22 134.95 285.95 124.32 292.09 124.31 259.36",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "129.63px 272.655px"
    },
    id: "elaeciqcvuck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcs7lmbsiz5b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135,262.23l-4.66,2.68v5.32a.64.64,0,0,0,1,.55l3.7-2.13Z",
    style: {
      opacity: 0.05,
      transformOrigin: "132.69px 266.561px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "134.94 253.22 132.97 252.08 122.34 258.22 124.31 259.36 134.94 253.22",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "128.64px 255.72px"
    },
    id: "elwo7vwq6xdhe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.39,263.82l4.88,2.81,1.95-3.38-4.88-2.81h0a.94.94,0,0,0-1,.09,3,3,0,0,0-1.38,2.39A1,1,0,0,0,128.39,263.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "131.589px 263.483px"
    },
    id: "elk82da60asy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1qktr954pyf"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "130.29 264.91 132.06 265.94 132.06 263.61 133.95 262.52 132.18 261.5 130.29 262.58 130.29 264.91",
    style: {
      opacity: 0.1,
      transformOrigin: "132.12px 263.72px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "132.65 263.98 132.65 269.09 152.15 257.84 152.15 252.73 132.65 263.98",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "142.4px 260.91px"
    },
    id: "elwec7r17fv0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.65 263.98 130.88 262.95 130.88 268.07 132.65 269.09 132.65 263.98",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "131.765px 266.02px"
    },
    id: "elzjwavomutk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.15 252.73 150.38 251.7 130.88 262.95 132.65 263.98 152.15 252.73",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "141.515px 257.84px"
    },
    id: "el1hzuxui1m1x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84,278.23a4,4,0,0,1,1.79-3.1c1-.57,1.79-.11,1.79,1a3.92,3.92,0,0,1-1.08,2.52V282a1.35,1.35,0,0,1-.61,1.05l-.2.12c-.34.19-.61,0-.61-.35v-3.34C128.28,279.56,127.84,279.08,127.84,278.23Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "129.63px 279.065px"
    },
    id: "elwataqekmpnn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Close--inject-32",
    className: "animable",
    style: {
      transformOrigin: "171.11px 200.078px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elwjdyno4o8k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.5,200.16l30.07-17.36c1.79-1,3.25-.2,3.25,1.87v20.65a7.21,7.21,0,0,1-3.25,5.63L155.5,228.31c-1.79,1-3.25.19-3.25-1.88V205.78A7.17,7.17,0,0,1,155.5,200.16Z",
    style: {
      opacity: 0.15,
      transformOrigin: "170.535px 205.554px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.65,201l30.07-17.36c1.79-1,3.25-.2,3.25,1.87v20.65a7.21,7.21,0,0,1-3.25,5.63l-30.07,17.36c-1.8,1-3.25.19-3.25-1.88V206.66A7.15,7.15,0,0,1,156.65,201Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "171.685px 206.394px"
    },
    id: "el0usf7joy5tze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59,198h-.08a.37.37,0,0,1-.29-.45l6.1-26.68a.36.36,0,0,1,.35-.29h0a.37.37,0,0,1,.36.26l6.1,19.65a.38.38,0,1,1-.72.22l-5.68-18.31L166,197.74A.38.38,0,0,1,165.59,198Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "171.687px 184.292px"
    },
    id: "elsnm6dj15b3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.66,220.88a.72.72,0,0,1-.09-.44V209.63a1.37,1.37,0,0,1,.09-.55.58.58,0,0,1,.29-.31l3.27-1.89c.11-.06.18,0,.23.05a1.51,1.51,0,0,1,.06.52v.45a2.41,2.41,0,0,1-.06.6.5.5,0,0,1-.23.31l-2.16,1.25v3L161,212c.1-.06.18,0,.22.05a1.3,1.3,0,0,1,.07.53V213a1.89,1.89,0,0,1-.07.6.55.55,0,0,1-.22.32L159.06,215v3.28l2.17-1.26a.15.15,0,0,1,.22,0,1.54,1.54,0,0,1,.06.53v.45a2.34,2.34,0,0,1-.06.61.54.54,0,0,1-.22.3l-3.28,1.9C157.81,220.93,157.71,220.94,157.66,220.88Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "159.539px 213.885px"
    },
    id: "el5jvkjrpyl6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.78,217.6v-11a1.19,1.19,0,0,1,.1-.53.72.72,0,0,1,.29-.33l1.81-1q2.25-1.31,2.25,2a5.9,5.9,0,0,1-1,3.53v.07c.3.08.55.56.76,1.44l.68,2.95a.44.44,0,0,0,0,.1.34.34,0,0,1,0,.1c0,.27-.2.52-.61.75l-.32.19c-.35.2-.55.18-.58-.06l-.62-3a1.21,1.21,0,0,0-.31-.64c-.12-.08-.29-.05-.53.09l-.42.24v4.26a1,1,0,0,1-.59.85l-.31.17C163,218,162.78,217.93,162.78,217.6Zm2.28-7.69a1.4,1.4,0,0,0,.51-.76,3.86,3.86,0,0,0,.22-1.37,2,2,0,0,0-.21-1.1q-.21-.27-.57-.06l-.76.44v3.32Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "165.226px 211.138px"
    },
    id: "ellqb2nrj5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.65,214.21v-11a1.38,1.38,0,0,1,.09-.54.8.8,0,0,1,.3-.33l1.81-1q2.25-1.31,2.25,2a5.94,5.94,0,0,1-1,3.53v.06c.3.09.55.57.76,1.45l.67,2.94,0,.1s0,.07,0,.11c0,.26-.2.51-.61.74l-.32.19c-.36.2-.55.18-.59-.06l-.61-3a1.19,1.19,0,0,0-.31-.63c-.12-.08-.3-.06-.54.08l-.41.24v4.27a1,1,0,0,1-.6.84l-.3.18C168.84,214.6,168.65,214.55,168.65,214.21Zm2.28-7.69a1.36,1.36,0,0,0,.51-.76,4.07,4.07,0,0,0,.21-1.37,1.92,1.92,0,0,0-.2-1.09.39.39,0,0,0-.57-.07l-.76.44V207Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "171.09px 207.741px"
    },
    id: "elap13bycclz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.29,205.36q0-6.15,2.89-7.82t2.89,4.48q0,6.18-2.89,7.85T174.29,205.36Zm3.93,1a13.59,13.59,0,0,0,.33-3.46,9.2,9.2,0,0,0-.33-3.07q-.33-.77-1-.36a2.49,2.49,0,0,0-1,1.56,13.45,13.45,0,0,0-.33,3.45,9.36,9.36,0,0,0,.33,3.08c.23.52.57.64,1,.37A2.55,2.55,0,0,0,178.22,206.36Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "177.18px 203.704px"
    },
    id: "elextq3ov6wtn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.35,206.88v-11a1.38,1.38,0,0,1,.09-.54.68.68,0,0,1,.3-.33l1.8-1q2.27-1.31,2.26,2a5.94,5.94,0,0,1-1.05,3.53v.06c.29.09.55.57.76,1.45l.67,2.94a.3.3,0,0,1,0,.1.41.41,0,0,1,0,.11c0,.26-.2.51-.6.74l-.33.19c-.35.2-.54.18-.58-.06l-.62-3a1.13,1.13,0,0,0-.31-.63c-.11-.09-.29-.06-.53.08l-.41.24V206a1,1,0,0,1-.6.84l-.3.17C181.54,207.27,181.35,207.21,181.35,206.88Zm2.27-7.69a1.32,1.32,0,0,0,.52-.76,4.11,4.11,0,0,0,.21-1.37,2,2,0,0,0-.21-1.1.39.39,0,0,0-.56-.06l-.76.44v3.32Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "183.767px 200.405px"
    },
    id: "eld0z57maov39",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tapes--inject-32",
    className: "animable",
    style: {
      transformOrigin: "169.44px 297.005px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "eleevniurj4bs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "112.53 369.86 108.83 367.75 108.84 380.2 112.53 382.31 112.53 369.86",
    style: {
      opacity: 0.2,
      transformOrigin: "110.68px 375.03px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "112.53 366.54 108.35 364.1 108.36 376.55 112.53 378.99 112.53 366.54",
    style: {
      fill: "current",
      transformOrigin: "110.44px 371.545px"
    },
    id: "el35mnqaf54uc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elweghk8pd16h"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "112.53 366.54 108.35 364.1 108.36 376.55 112.53 378.99 112.53 366.54",
    style: {
      opacity: 0.2,
      transformOrigin: "110.44px 371.545px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elekpkwi5gfmq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "230.53 215.01 112.53 369.86 112.54 382.31 230.53 227.47 230.53 215.01",
    style: {
      opacity: 0.25,
      transformOrigin: "171.53px 298.66px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "230.53 211.7 112.53 366.54 112.54 378.99 230.53 224.15 230.53 211.7",
    style: {
      fill: "current",
      transformOrigin: "171.53px 295.345px"
    },
    id: "elkoqhez407r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.53 224.13 230.53 218.48 224.68 219.38 219.81 225.77 230.53 224.13",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "225.17px 222.125px"
    },
    id: "elp8mfm6s859e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.94 243.32 205.18 244.97 200.3 251.37 211.07 249.71 215.94 243.32",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "208.12px 247.345px"
    },
    id: "ell95llc8emg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.69 230.52 214.93 232.17 210.05 238.57 220.82 236.92 225.69 230.52",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "217.87px 234.545px"
    },
    id: "elcq3epia5v6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.19 256.11 195.43 257.77 190.55 264.16 201.32 262.51 206.19 256.11",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "198.37px 260.135px"
    },
    id: "el3b3vh2a73my",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.44 268.91 185.67 270.56 180.8 276.96 191.56 275.31 196.44 268.91",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "188.62px 272.935px"
    },
    id: "el7cckp9uj5np",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.69 281.71 175.92 283.36 171.05 289.76 181.81 288.11 186.69 281.71",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "178.87px 285.735px"
    },
    id: "elj34dpomkkmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.94 294.5 166.17 296.16 161.29 302.55 172.06 300.9 176.94 294.5",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "169.115px 298.525px"
    },
    id: "elkgnvmm81nn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.18 307.3 156.42 308.95 151.54 315.35 162.31 313.7 167.18 307.3",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "159.36px 311.325px"
    },
    id: "el7zn4ahogghp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.43 320.1 146.67 321.75 141.79 328.15 152.56 326.5 157.43 320.1",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "149.61px 324.125px"
    },
    id: "elhrvti5x7eap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.68 332.89 136.91 334.55 132.04 340.94 142.81 339.29 147.68 332.89",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "139.86px 336.915px"
    },
    id: "el78lbeney3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.93 345.69 127.16 347.34 122.29 353.74 133.05 352.09 137.93 345.69",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "130.11px 349.715px"
    },
    id: "eldovr3e3hr79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.18 358.49 117.41 360.14 112.53 366.54 123.3 364.88 128.18 358.49",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "120.355px 362.515px"
    },
    id: "elgzn9ozz01lk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.41 371.29 112.53 372.19 112.53 378.99 113.53 377.68 118.41 371.29",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.47px 375.14px"
    },
    id: "el8rn9tje55ev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el60f8u4oohdu"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "112.53 283.52 230.53 298.93 230.53 311.38 112.53 295.98 112.53 283.52",
    style: {
      opacity: 0.25,
      transformOrigin: "171.53px 297.45px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "112.53 281.42 230.53 296.82 230.53 309.27 112.53 293.87 112.53 281.42",
    style: {
      fill: "current",
      transformOrigin: "171.53px 295.345px"
    },
    id: "elkh9y79ou9aj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3y9d9ykwu85"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "112.53 283.52 108.83 281.35 108.84 293.81 112.53 295.97 112.53 283.52",
    style: {
      opacity: 0.2,
      transformOrigin: "110.68px 288.66px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "112.53 281.42 108.35 278.97 108.36 291.43 112.53 293.87 112.53 281.42",
    style: {
      fill: "current",
      transformOrigin: "110.44px 286.42px"
    },
    id: "elqwvloc21lai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elslqlvort13t"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "112.53 281.42 108.35 278.97 108.36 291.43 112.53 293.87 112.53 281.42",
    style: {
      opacity: 0.2,
      transformOrigin: "110.44px 286.42px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,284.78s.06,0,.07.09a.54.54,0,0,1,0,.22l-.17,1.15a.52.52,0,0,1-.06.2c0,.06-.07.08-.1.08l-1.34-.17-.22,1.48,1.25.16s.06,0,.08.1a.74.74,0,0,1,0,.21l-.17,1.16a.66.66,0,0,1-.06.2s-.07.08-.1.07l-1.25-.16-.34,2.35a.77.77,0,0,1-.07.2c0,.06-.07.09-.1.08l-.59-.07s0,0-.07-.1a.49.49,0,0,1,0-.21l1-7a.59.59,0,0,1,.06-.2s.07-.08.1-.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "116.215px 288.371px"
    },
    id: "el4piz2hsxnhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.2,287.72a7.33,7.33,0,0,1,.27-1.14,4.74,4.74,0,0,1,.41-.9,1.83,1.83,0,0,1,.53-.57A.8.8,0,0,1,120,285a.81.81,0,0,1,.55.31,1.82,1.82,0,0,1,.35.68,4.55,4.55,0,0,1,.13,1,7.67,7.67,0,0,1,0,1.16c0,.32-.09.64-.14,1s-.1.66-.15,1a7.47,7.47,0,0,1-.27,1.13,4.85,4.85,0,0,1-.41.91,2,2,0,0,1-.53.57.86.86,0,0,1-.61.16.84.84,0,0,1-.56-.31,1.88,1.88,0,0,1-.34-.68,4,4,0,0,1-.13-1,7.78,7.78,0,0,1,0-1.16c0-.3.08-.62.13-1S118.14,288,118.2,287.72Zm1.69,2.13c0-.13,0-.28.07-.43s.06-.33.08-.49,0-.33.07-.49,0-.29,0-.42a2.9,2.9,0,0,0,0-.5,1.58,1.58,0,0,0-.05-.41.71.71,0,0,0-.13-.29.34.34,0,0,0-.48-.06.74.74,0,0,0-.22.24,2.29,2.29,0,0,0-.16.38,3.33,3.33,0,0,0-.12.5,3.86,3.86,0,0,0-.07.41c0,.16,0,.32-.08.49s0,.33-.07.49,0,.3,0,.43a2.79,2.79,0,0,0,0,.93c0,.25.17.39.36.41a.47.47,0,0,0,.46-.31A2.93,2.93,0,0,0,119.89,289.85Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "119.46px 288.955px"
    },
    id: "elleiy6tk77k8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.63,285.52a1,1,0,0,1,.5.22,1.3,1.3,0,0,1,.34.51,2.92,2.92,0,0,1,.13.81,5.59,5.59,0,0,1-.07,1.11,5.42,5.42,0,0,1-.34,1.34,1.91,1.91,0,0,1-.51.77l.18,2.66v.12a.38.38,0,0,1-.06.16s0,.07-.08.07l-.61-.08a.13.13,0,0,1-.11-.12.69.69,0,0,1,0-.2l-.16-2.39-.42-.05-.34,2.32a.52.52,0,0,1-.06.2c0,.06-.07.09-.1.08l-.59-.07s0,0-.07-.1a.49.49,0,0,1,0-.21l1-7a.59.59,0,0,1,.06-.2c0-.05.07-.08.1-.08Zm-1,3.23.51.07a.37.37,0,0,0,.33-.14,1.11,1.11,0,0,0,.22-.61,1.27,1.27,0,0,0,0-.65.35.35,0,0,0-.29-.21l-.51-.07Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "122.926px 289.34px"
    },
    id: "elk2wnc4mx84c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.75,293.42a.12.12,0,0,1-.07-.1.48.48,0,0,1,0-.21l1-7a.93.93,0,0,1,.07-.2c0-.05.07-.08.1-.07l1.44.18a.69.69,0,0,1,.48.27,1.37,1.37,0,0,1,.25.56,2.93,2.93,0,0,1,.08.75,7.35,7.35,0,0,1-.07.82,3.19,3.19,0,0,1-.11.54,4,4,0,0,1-.12.4c0,.11-.09.19-.13.26l-.09.15a2,2,0,0,1,.15.71,7.05,7.05,0,0,1-.07.94,6.25,6.25,0,0,1-.18.86,3.27,3.27,0,0,1-.29.73,1.32,1.32,0,0,1-.4.49.63.63,0,0,1-.51.14Zm1-1.6.74.1c.09,0,.17-.05.24-.17a1.24,1.24,0,0,0,.15-.46,1.26,1.26,0,0,0,0-.48c0-.14-.1-.21-.19-.22l-.74-.09Zm1.49-3.49a1.17,1.17,0,0,0,0-.46c0-.12-.09-.19-.18-.2l-.7-.09-.18,1.24.7.09c.09,0,.16,0,.23-.14A1.44,1.44,0,0,0,127.2,288.33Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "126.385px 289.743px"
    },
    id: "eluprj35fqfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.27,293.87s-.05,0-.07-.1a.49.49,0,0,1,0-.21l1-7a.59.59,0,0,1,.06-.2c0-.05.07-.08.1-.07l.59.07a.12.12,0,0,1,.07.1.48.48,0,0,1,0,.21l-1,7a.86.86,0,0,1-.07.21c0,.05-.07.08-.1.07Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "129.11px 290.12px"
    },
    id: "elq8beiqu15aa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.37,286.64a.83.83,0,0,1,.53.29,1.72,1.72,0,0,1,.35.69,3.94,3.94,0,0,1,.16,1,8.93,8.93,0,0,1-.06,1.24q0,.24-.06.42c0,.13,0,.25,0,.37s0,.23-.06.36a3.55,3.55,0,0,1-.06.4,7.41,7.41,0,0,1-.29,1.21,4.66,4.66,0,0,1-.43.92,1.94,1.94,0,0,1-.52.57.81.81,0,0,1-.59.15l-1.22-.15s0,0-.07-.1a.7.7,0,0,1,0-.21l1-7a.59.59,0,0,1,.06-.2c0-.05.07-.08.1-.07Zm.15,3.06c.11-.83,0-1.28-.42-1.32l-.46-.06-.6,4.13.48.06c.37.05.63-.34.77-1.18l.06-.42.06-.4.06-.38C132.49,290,132.5,289.86,132.52,289.7Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "131.727px 290.398px"
    },
    id: "eljojphjvwny",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,287.1a.79.79,0,0,1,.53.29,1.75,1.75,0,0,1,.35.68,4.1,4.1,0,0,1,.16,1,8.93,8.93,0,0,1-.06,1.24c0,.16,0,.29-.06.42s0,.25,0,.37,0,.23-.05.35,0,.26-.07.41a7.67,7.67,0,0,1-.29,1.21,4.66,4.66,0,0,1-.43.92,1.94,1.94,0,0,1-.52.57.81.81,0,0,1-.59.15l-1.22-.15s0,0-.07-.1a.49.49,0,0,1,0-.21l1-7a.59.59,0,0,1,.06-.2s.07-.08.1-.07Zm.15,3.06c.11-.83,0-1.28-.42-1.33l-.46-.05-.6,4.13.48.06c.37,0,.63-.34.77-1.18l.06-.43L136,291l.06-.38C136.08,290.46,136.09,290.32,136.11,290.16Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "135.355px 290.848px"
    },
    id: "elf2scofdgpv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.62,293.55s0,0,.07.09a.49.49,0,0,1,0,.21l-.16,1.16a.93.93,0,0,1-.07.2.14.14,0,0,1-.1.08l-2.13-.28s0,0-.07-.1a.67.67,0,0,1,0-.2l1-7a.52.52,0,0,1,.06-.2c0-.06.07-.08.1-.08l2.09.27s.06,0,.08.1a.74.74,0,0,1,0,.21l-.17,1.15a.52.52,0,0,1-.06.2c0,.06-.07.08-.1.08l-1.38-.18-.17,1.18,1.28.16a.12.12,0,0,1,.07.1.48.48,0,0,1,0,.21l-.17,1.15a.65.65,0,0,1-.06.21c0,.05-.07.08-.1.07l-1.28-.16-.18,1.21Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "138.825px 291.36px"
    },
    id: "elqztu82mejur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.39,295.67s-.08,0-.1-.11a.41.41,0,0,1,0-.16l-.49-3.85-.53,3.67a.77.77,0,0,1-.07.2c0,.06-.07.09-.1.08l-.59-.07s-.05,0-.07-.1a.7.7,0,0,1,0-.21l1-7a.59.59,0,0,1,.06-.2c0-.05.07-.08.1-.07l.47.06s.09,0,.11.11,0,.12,0,.16l.48,3.85.54-3.68a.59.59,0,0,1,.06-.2c0-.05.07-.08.1-.07l.59.07s.06,0,.07.1a.48.48,0,0,1,0,.21l-1,7a.65.65,0,0,1-.06.21s-.07.08-.1.07Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "142.232px 291.794px"
    },
    id: "el3410b1l5wki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,296.22s-.06,0-.08-.09a.74.74,0,0,1,0-.21l.16-1.11-1.41-.18s-.06,0-.08-.1a.74.74,0,0,1,0-.21l.17-1.15a1.4,1.4,0,0,1,.12-.47l1.94-3.92a.42.42,0,0,1,.1-.15.14.14,0,0,1,.09,0l.68.09s.06,0,.07.1a.48.48,0,0,1,0,.21l-.61,4.17.39.05a.12.12,0,0,1,.07.1.48.48,0,0,1,0,.21l-.17,1.15a.48.48,0,0,1-.07.21c0,.05-.06.08-.09.07l-.39,0-.16,1.11a.52.52,0,0,1-.07.2c0,.06-.06.08-.1.08Zm.35-3.15.3-2-1,1.92Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "146.897px 292.501px"
    },
    id: "eljr0p5a2l4z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,288.92a.79.79,0,0,1,.54.31,1.88,1.88,0,0,1,.31.7,4.59,4.59,0,0,1,.1,1A11.23,11.23,0,0,1,152,292c0,.32-.09.64-.14,1s-.1.66-.14,1a11.3,11.3,0,0,1-.26,1.11,4.09,4.09,0,0,1-.38.91,1.84,1.84,0,0,1-.49.59.81.81,0,0,1-.61.17.79.79,0,0,1-.55-.31,1.81,1.81,0,0,1-.31-.7,4.59,4.59,0,0,1-.1-1,11.23,11.23,0,0,1,.07-1.13c0-.3.08-.62.13-1s.1-.67.16-1a9,9,0,0,1,.25-1.11,4.09,4.09,0,0,1,.38-.91,1.84,1.84,0,0,1,.49-.59A.82.82,0,0,1,151.09,288.92Zm-.23,4.89c.1-.62.19-1.22.27-1.83,0-.18,0-.35,0-.5a2.55,2.55,0,0,0,0-.41.71.71,0,0,0-.11-.28.27.27,0,0,0-.21-.13.3.3,0,0,0-.24.07.7.7,0,0,0-.18.25,2.35,2.35,0,0,0-.14.38c0,.15-.07.32-.1.5q-.15.9-.27,1.83a4.77,4.77,0,0,0,0,.5,1.76,1.76,0,0,0,0,.41.66.66,0,0,0,.11.28.27.27,0,0,0,.21.13.3.3,0,0,0,.24-.07.7.7,0,0,0,.18-.25,1.68,1.68,0,0,0,.14-.38C150.8,294.16,150.83,294,150.86,293.81Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "150.53px 292.846px"
    },
    id: "elh4pe8epsqvl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,289.6s.06,0,.07.09a.49.49,0,0,1,0,.21l-.17,1.16a.65.65,0,0,1-.06.21l-.09.16-.73,1.25a1.59,1.59,0,0,1,.46.81,3.34,3.34,0,0,1,0,1.39,3.93,3.93,0,0,1-.62,1.81,1.09,1.09,0,0,1-1.06.49.92.92,0,0,1-.55-.26,1.49,1.49,0,0,1-.35-.54,2.71,2.71,0,0,1-.16-.72,3.56,3.56,0,0,1,0-.8.69.69,0,0,1,0-.17s.05-.06.08-.06l.57.07a.17.17,0,0,1,.13.12,2.17,2.17,0,0,0,.07.24.7.7,0,0,0,.13.24.32.32,0,0,0,.26.14.43.43,0,0,0,.38-.13.84.84,0,0,0,.22-.53.86.86,0,0,0-.06-.58.47.47,0,0,0-.33-.22l-.37,0a.12.12,0,0,1-.07-.1.48.48,0,0,1,0-.21l.14-.94a.65.65,0,0,1,.06-.21l.09-.17.64-1.1-1.17-.15s-.06,0-.07-.1a.48.48,0,0,1,0-.21l.17-1.15a.4.4,0,0,1,.07-.2c0-.06.06-.08.09-.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "153.909px 293.275px"
    },
    id: "elm6zhdqj416k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.1,290.18s.06,0,.08.1a.74.74,0,0,1,0,.21l-.17,1.15a.58.58,0,0,1-.06.21s-.07.08-.1.07l-1.34-.17-.22,1.49,1.25.16s.06,0,.08.1a.74.74,0,0,1,0,.21l-.17,1.15a.65.65,0,0,1-.06.21c0,.05-.07.08-.1.07L158,295l-.34,2.35a.52.52,0,0,1-.07.2c0,.06-.06.08-.1.08l-.59-.08s-.05,0-.07-.09a.54.54,0,0,1,0-.22l1-7a.52.52,0,0,1,.06-.2c0-.06.07-.08.1-.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "158.503px 293.795px"
    },
    id: "elf3ek7ze56mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.47,293.12a8.91,8.91,0,0,1,.27-1.13,4.74,4.74,0,0,1,.41-.9,2.15,2.15,0,0,1,.53-.58.91.91,0,0,1,.62-.16.86.86,0,0,1,.55.31,2,2,0,0,1,.34.69,3.93,3.93,0,0,1,.13,1,6.63,6.63,0,0,1,0,1.16c0,.31-.09.64-.14,1s-.1.66-.14,1a8.64,8.64,0,0,1-.28,1.14,4.19,4.19,0,0,1-.41.9,1.88,1.88,0,0,1-.53.58.84.84,0,0,1-.61.15.89.89,0,0,1-.56-.3,1.93,1.93,0,0,1-.33-.69,3.9,3.9,0,0,1-.14-1,7.71,7.71,0,0,1,.06-1.16c0-.3.08-.62.13-1S160.42,293.43,160.47,293.12Zm1.69,2.13c0-.13.05-.27.08-.43s0-.32.07-.49.05-.33.07-.48,0-.3.05-.42a4.77,4.77,0,0,0,0-.51,2.42,2.42,0,0,0-.05-.41.78.78,0,0,0-.14-.29.34.34,0,0,0-.23-.13.32.32,0,0,0-.25.07.83.83,0,0,0-.21.24,1.76,1.76,0,0,0-.17.39,3.19,3.19,0,0,0-.12.49c0,.12,0,.26-.07.42s-.05.31-.08.48l-.06.49c0,.16,0,.31-.06.44a2.73,2.73,0,0,0,0,.92c0,.25.17.39.36.41s.34-.08.47-.3A3,3,0,0,0,162.16,295.25Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "161.762px 294.317px"
    },
    id: "ellt0irhkv7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,290.92a1,1,0,0,1,.51.22,1.19,1.19,0,0,1,.33.51,2.64,2.64,0,0,1,.13.81,5.59,5.59,0,0,1-.07,1.11,6,6,0,0,1-.33,1.34,2,2,0,0,1-.52.77l.18,2.66a.48.48,0,0,1,0,.12.43.43,0,0,1-.06.17.1.1,0,0,1-.07.06l-.62-.08a.14.14,0,0,1-.11-.11.76.76,0,0,1,0-.21l-.16-2.39-.41,0-.34,2.33a.59.59,0,0,1-.07.2c0,.05-.06.08-.1.07l-.58-.07s-.06,0-.08-.1a.74.74,0,0,1,0-.21l1-7a.48.48,0,0,1,.07-.21s.06-.08.09-.07Zm-1,3.23.51.07a.39.39,0,0,0,.34-.14,1.12,1.12,0,0,0,.21-.61,1.08,1.08,0,0,0,0-.65.35.35,0,0,0-.29-.21l-.5-.07Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "165.188px 294.765px"
    },
    id: "elndgafxjer8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,298.82s-.06,0-.07-.1a.48.48,0,0,1,0-.21l1-7a.65.65,0,0,1,.07-.21s.06-.08.1-.07l1.44.18a.73.73,0,0,1,.48.27,1.37,1.37,0,0,1,.25.56,3,3,0,0,1,.07.75,5.55,5.55,0,0,1-.06.82,5.33,5.33,0,0,1-.11.55,2.54,2.54,0,0,1-.13.39,1.29,1.29,0,0,1-.12.26l-.09.15a1.8,1.8,0,0,1,.14.71,5.5,5.5,0,0,1-.06.94c-.05.3-.11.58-.18.86a3.83,3.83,0,0,1-.29.73,1.47,1.47,0,0,1-.4.5.67.67,0,0,1-.51.14Zm.95-1.6.74.1c.09,0,.17,0,.25-.16a1.37,1.37,0,0,0,.15-.47,1.25,1.25,0,0,0,0-.48c0-.13-.09-.21-.18-.22l-.74-.09Zm1.5-3.49a1.4,1.4,0,0,0,0-.46c0-.12-.09-.19-.18-.2l-.7-.09-.18,1.24.7.09a.22.22,0,0,0,.22-.14A1.14,1.14,0,0,0,169.47,293.73Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "168.63px 295.138px"
    },
    id: "elnls59rnjuh8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.55,299.27s-.06,0-.07-.1a.48.48,0,0,1,0-.21l1-7a.52.52,0,0,1,.07-.2c0-.06.06-.08.1-.08l.58.08s.06,0,.08.09a.74.74,0,0,1,0,.21l-1,7a.4.4,0,0,1-.07.2c0,.06-.06.08-.09.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "171.393px 295.51px"
    },
    id: "elutbu3we5tpo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.66,292a.82.82,0,0,1,.53.3,1.75,1.75,0,0,1,.35.68,4.1,4.1,0,0,1,.16,1,9,9,0,0,1-.06,1.24q0,.23-.06.42c0,.13,0,.25-.05.36s0,.24-.05.36,0,.26-.07.4a7.54,7.54,0,0,1-.29,1.22,4.94,4.94,0,0,1-.43.92,1.94,1.94,0,0,1-.52.57.86.86,0,0,1-.59.15l-1.22-.16s-.05,0-.07-.09a.5.5,0,0,1,0-.21l1-7a.52.52,0,0,1,.06-.2c0-.06.07-.08.1-.08Zm.15,3.07c.11-.84,0-1.28-.42-1.33l-.46-.06-.6,4.13.48.07c.37,0,.63-.35.77-1.18l.06-.43.06-.39.06-.39C174.78,295.4,174.79,295.26,174.81,295.11Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "173.99px 295.753px"
    },
    id: "el6dh13a1sdjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.25,292.5a.87.87,0,0,1,.53.3,1.75,1.75,0,0,1,.35.68,3.63,3.63,0,0,1,.15,1,6.71,6.71,0,0,1-.06,1.24c0,.15,0,.29-.05.42s0,.25,0,.36l-.06.36c0,.12,0,.26-.06.4a6.81,6.81,0,0,1-.3,1.22,4.38,4.38,0,0,1-.42.92,1.94,1.94,0,0,1-.52.57.93.93,0,0,1-.6.15L176,300s-.06,0-.07-.1a.48.48,0,0,1,0-.21l1-7a.77.77,0,0,1,.07-.2c0-.06.07-.08.1-.08Zm.15,3.07c.1-.84,0-1.28-.43-1.33l-.46-.06-.6,4.13.48.06c.38.05.64-.34.77-1.17,0-.15.05-.3.07-.43l.06-.39c0-.13,0-.26.05-.39S178.38,295.72,178.4,295.57Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "177.602px 296.267px"
    },
    id: "elokaxoj19w8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,299s.05,0,.07.1a.49.49,0,0,1,0,.21l-.16,1.15a.77.77,0,0,1-.07.2c0,.06-.07.09-.1.08l-2.12-.27s-.06,0-.08-.1a.74.74,0,0,1,0-.21l1-7a.48.48,0,0,1,.07-.21c0-.05.06-.08.09-.07l2.09.27s.06,0,.08.09a.8.8,0,0,1,0,.22l-.17,1.15a.59.59,0,0,1-.06.2.14.14,0,0,1-.1.08l-1.38-.18-.17,1.17,1.28.17s.06,0,.07.1a.48.48,0,0,1,0,.21l-.17,1.15a.52.52,0,0,1-.06.2c0,.06-.07.08-.1.08l-1.29-.17-.17,1.22Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "181.115px 296.81px"
    },
    id: "elxt5a87vmd1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,301.08a.15.15,0,0,1-.11-.12.73.73,0,0,1,0-.16L184,297l-.53,3.68a.4.4,0,0,1-.07.2c0,.06-.06.08-.09.08l-.59-.08s-.06,0-.07-.1a.48.48,0,0,1,0-.21l1-7a.52.52,0,0,1,.07-.2c0-.06.06-.08.1-.08l.46.06a.14.14,0,0,1,.11.11.9.9,0,0,1,0,.16l.49,3.85.53-3.67a.4.4,0,0,1,.07-.2c0-.06.06-.08.09-.08l.59.07s.06,0,.08.1a.74.74,0,0,1,0,.21l-1,7a.4.4,0,0,1-.07.2c0,.06-.06.08-.09.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "184.443px 297.235px"
    },
    id: "elmzzow9tzgnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,301.63a.12.12,0,0,1-.07-.1.48.48,0,0,1,0-.21l.16-1.11-1.41-.18s-.06,0-.07-.1a.48.48,0,0,1,0-.21l.17-1.15a1.61,1.61,0,0,1,.12-.46l1.94-3.93a.42.42,0,0,1,.1-.15.11.11,0,0,1,.1,0l.67.08s.06,0,.08.1a.74.74,0,0,1,0,.21l-.6,4.18.38.05s.06,0,.07.09a.53.53,0,0,1,0,.22l-.17,1.15a.52.52,0,0,1-.06.2s-.07.08-.1.08l-.39-.05-.16,1.11a.43.43,0,0,1-.07.2c0,.05-.06.08-.09.07Zm.36-3.16.29-2-.95,1.92Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "189.198px 297.87px"
    },
    id: "elzcc6ceqtvpq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.37,294.33a.76.76,0,0,1,.54.31,1.83,1.83,0,0,1,.31.69,4.07,4.07,0,0,1,.1,1,8.94,8.94,0,0,1-.07,1.14c0,.31-.08.64-.13,1s-.1.66-.15.95a8.77,8.77,0,0,1-.26,1.12,4.53,4.53,0,0,1-.37.91,2,2,0,0,1-.5.59.79.79,0,0,1-.61.16.76.76,0,0,1-.55-.31,1.83,1.83,0,0,1-.3-.69,4.63,4.63,0,0,1-.11-1,9,9,0,0,1,.08-1.14c0-.3.08-.62.13-1s.1-.66.15-1a9,9,0,0,1,.25-1.11,4.53,4.53,0,0,1,.38-.91,2,2,0,0,1,.49-.59A.82.82,0,0,1,193.37,294.33Zm-.23,4.88c.11-.61.19-1.22.27-1.82,0-.18,0-.35,0-.51a1.67,1.67,0,0,0,0-.4.7.7,0,0,0-.11-.29.28.28,0,0,0-.21-.12.26.26,0,0,0-.23.06.86.86,0,0,0-.19.25,2.49,2.49,0,0,0-.14.39,4.9,4.9,0,0,0-.1.5c-.1.59-.19,1.2-.27,1.82,0,.18,0,.35,0,.5a1.73,1.73,0,0,0,0,.41.7.7,0,0,0,.11.29.28.28,0,0,0,.21.12.29.29,0,0,0,.24-.06.7.7,0,0,0,.18-.25,1.77,1.77,0,0,0,.14-.39A3.15,3.15,0,0,0,193.14,299.21Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "192.796px 298.261px"
    },
    id: "elaz98z50cdwt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.78,295s.05,0,.07.1a.7.7,0,0,1,0,.21l-.17,1.15a.65.65,0,0,1-.07.21.79.79,0,0,1-.08.16l-.73,1.26a1.52,1.52,0,0,1,.46.8,3.57,3.57,0,0,1,0,1.4,3.84,3.84,0,0,1-.62,1.8,1.13,1.13,0,0,1-1.07.5,1,1,0,0,1-.54-.26,1.48,1.48,0,0,1-.35-.55,2.54,2.54,0,0,1-.16-.72,3.07,3.07,0,0,1,0-.8.42.42,0,0,1,.05-.17s0-.06.08-.06l.57.08q.09,0,.12.12c0,.07.05.15.08.23a.85.85,0,0,0,.13.25.34.34,0,0,0,.26.13.45.45,0,0,0,.38-.12.94.94,0,0,0,.22-.54.84.84,0,0,0-.06-.57.44.44,0,0,0-.33-.22l-.37-.05s-.06,0-.08-.1a.74.74,0,0,1,0-.21l.13-.93a.81.81,0,0,1,.07-.22l.09-.16.64-1.11-1.17-.14a.12.12,0,0,1-.07-.1.48.48,0,0,1,0-.21l.17-1.16a.59.59,0,0,1,.06-.2c0-.05.07-.08.1-.07Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "196.176px 298.663px"
    },
    id: "el3mozz31fqxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.36,295.59s.06,0,.08.09a.81.81,0,0,1,0,.22l-.17,1.15a.59.59,0,0,1-.06.2c0,.05-.07.08-.1.08l-1.34-.18-.22,1.49,1.25.16s.06,0,.08.1a.74.74,0,0,1,0,.21l-.17,1.16a.59.59,0,0,1-.06.2s-.07.08-.1.07l-1.25-.16-.34,2.35a.77.77,0,0,1-.07.2c0,.06-.06.08-.1.08l-.59-.08s0,0-.07-.09a.49.49,0,0,1,0-.21l1-7a.59.59,0,0,1,.06-.2c0-.06.07-.08.1-.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "200.783px 299.18px"
    },
    id: "elagnadmp6u9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,298.53a7.18,7.18,0,0,1,.28-1.13,3.78,3.78,0,0,1,.41-.9,2,2,0,0,1,.52-.58.87.87,0,0,1,.62-.16.84.84,0,0,1,.55.31,1.89,1.89,0,0,1,.34.68,4.06,4.06,0,0,1,.14,1,7.85,7.85,0,0,1-.06,1.16c0,.31-.08.63-.13,1s-.1.66-.15.95A7.6,7.6,0,0,1,205,302a3.94,3.94,0,0,1-.41.9,1.85,1.85,0,0,1-.52.58.88.88,0,0,1-1.17-.15,1.86,1.86,0,0,1-.34-.69,4.52,4.52,0,0,1-.14-1,7.91,7.91,0,0,1,.06-1.17c0-.29.08-.61.13-.95S202.71,298.84,202.76,298.53Zm1.7,2.13c0-.13,0-.27.07-.43s.05-.32.08-.49l.06-.49c0-.15,0-.29.05-.42a3,3,0,0,0,0-.5,1.64,1.64,0,0,0-.05-.41.71.71,0,0,0-.13-.29.32.32,0,0,0-.23-.13.36.36,0,0,0-.26.07.63.63,0,0,0-.21.24,2.7,2.7,0,0,0-.17.38c0,.15-.08.32-.11.5s-.05.26-.08.42,0,.31-.07.48-.05.33-.07.49,0,.3-.05.44a3,3,0,0,0,0,.92c.06.25.18.39.37.41a.47.47,0,0,0,.46-.31A2.83,2.83,0,0,0,204.46,300.66Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "204.02px 299.695px"
    },
    id: "eljij3h89yn9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.17,296.33a.91.91,0,0,1,.5.22,1.13,1.13,0,0,1,.33.5,2.62,2.62,0,0,1,.14.81,6.52,6.52,0,0,1-.07,1.12,5.54,5.54,0,0,1-.34,1.34,2,2,0,0,1-.51.77l.18,2.65v.12a.43.43,0,0,1-.06.17c0,.05-.05.06-.08.06l-.61-.08c-.06,0-.1,0-.11-.11a.75.75,0,0,1,0-.2l-.16-2.39-.42-.06-.34,2.33a.52.52,0,0,1-.06.2c0,.06-.07.08-.1.08l-.59-.08s-.05,0-.07-.09a.79.79,0,0,1,0-.22l1-7a.52.52,0,0,1,.06-.2c0-.06.07-.08.1-.08Zm-1,3.23.51.06a.37.37,0,0,0,.33-.13,1.68,1.68,0,0,0,.19-1.26.38.38,0,0,0-.29-.22l-.51-.06Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "207.467px 300.14px"
    },
    id: "elfpvi3c4atb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.29,304.22s-.06,0-.07-.09a.48.48,0,0,1,0-.21l1-7a.77.77,0,0,1,.07-.2c0-.06.06-.08.1-.08l1.44.19a.68.68,0,0,1,.48.26,1.41,1.41,0,0,1,.25.57,2.52,2.52,0,0,1,.07.75,5.55,5.55,0,0,1-.06.82,4.63,4.63,0,0,1-.11.54,2.35,2.35,0,0,1-.13.4,2.17,2.17,0,0,1-.12.26l-.09.14a1.85,1.85,0,0,1,.14.72,5.39,5.39,0,0,1-.06.93,6.09,6.09,0,0,1-.18.87,3.27,3.27,0,0,1-.29.73,1.53,1.53,0,0,1-.4.49.67.67,0,0,1-.51.14Zm1-1.59.75.09c.08,0,.16,0,.24-.16a1.31,1.31,0,0,0,.15-.46,1.5,1.5,0,0,0,0-.48c0-.14-.1-.21-.19-.22l-.74-.1Zm1.5-3.5a1.17,1.17,0,0,0,0-.46c0-.12-.09-.18-.18-.19l-.7-.09-.18,1.24.7.09c.09,0,.16,0,.23-.14A1.43,1.43,0,0,0,211.74,299.13Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "210.921px 300.548px"
    },
    id: "el28eo486bkfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.83,304.68s-.06,0-.08-.1a.74.74,0,0,1,0-.21l1-7a.43.43,0,0,1,.07-.2c0-.05.06-.08.09-.07l.59.07s.06,0,.07.1a.48.48,0,0,1,0,.21l-1,7a.52.52,0,0,1-.07.2c0,.06-.06.09-.1.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "213.662px 300.93px"
    },
    id: "elhyg1jw75u6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.92,297.45a.81.81,0,0,1,.53.29,1.89,1.89,0,0,1,.35.68,4.13,4.13,0,0,1,.15,1,6.68,6.68,0,0,1-.06,1.24c0,.15,0,.29,0,.42l-.06.37c0,.11,0,.23-.05.35s0,.26-.06.41a7.64,7.64,0,0,1-.3,1.21,4.15,4.15,0,0,1-.42.92,2,2,0,0,1-.53.57.8.8,0,0,1-.59.15l-1.21-.15a.12.12,0,0,1-.07-.1.48.48,0,0,1,0-.21l1-7a.59.59,0,0,1,.07-.2c0-.05.06-.08.1-.07Zm.15,3.06c.1-.83,0-1.28-.43-1.33l-.46-.06-.6,4.14.48.06c.38.05.64-.35.77-1.18,0-.15,0-.29.07-.43l.06-.39c0-.12,0-.25,0-.38S217.05,300.66,217.07,300.51Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "216.273px 301.198px"
    },
    id: "elx2socbys5mp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,297.91a.81.81,0,0,1,.54.29,2.06,2.06,0,0,1,.35.68,4.69,4.69,0,0,1,.15,1,6.68,6.68,0,0,1-.06,1.24l-.06.42c0,.13,0,.25-.05.36s0,.24,0,.36l-.06.4a8.71,8.71,0,0,1-.3,1.22,4.15,4.15,0,0,1-.42.92,2,2,0,0,1-.53.57.81.81,0,0,1-.59.15l-1.21-.16s-.06,0-.08-.09a.74.74,0,0,1,0-.21l1-7a.4.4,0,0,1,.07-.2c0-.06.06-.08.1-.08Zm.16,3.06c.1-.83,0-1.28-.43-1.33l-.46-.06-.6,4.14.48.06c.38,0,.63-.35.77-1.18,0-.15,0-.29.07-.43s0-.26.05-.39l.06-.38C220.63,301.27,220.65,301.12,220.67,301Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "219.87px 301.654px"
    },
    id: "eloi2bl1mamci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.18,304.36s0,0,.07.09a.49.49,0,0,1,0,.21l-.16,1.16a.93.93,0,0,1-.07.2c0,.05-.06.08-.1.07l-2.13-.27s0,0-.07-.09a.74.74,0,0,1,0-.21l1-7a.4.4,0,0,1,.07-.2c0-.06.06-.08.09-.08l2.09.27s.06,0,.08.1a.74.74,0,0,1,0,.21l-.17,1.15a.52.52,0,0,1-.06.2c0,.06-.07.08-.1.08l-1.38-.18-.17,1.18,1.28.16a.12.12,0,0,1,.07.1.48.48,0,0,1,0,.21l-.17,1.15a.52.52,0,0,1-.06.2c0,.06-.07.08-.1.08l-1.29-.16-.17,1.21Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "223.385px 302.166px"
    },
    id: "ele4mqwoiwr3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.94,306.48c-.05,0-.08,0-.11-.11a.69.69,0,0,1,0-.16l-.49-3.85-.54,3.67a.52.52,0,0,1-.06.2c0,.06-.07.08-.1.08l-.59-.08s-.06,0-.07-.09a.48.48,0,0,1,0-.21l1-7a.52.52,0,0,1,.06-.2c0-.06.07-.08.1-.08l.47.06c.05,0,.08.05.1.12a.41.41,0,0,1,0,.16l.49,3.85.53-3.68a.77.77,0,0,1,.07-.2.14.14,0,0,1,.1-.08l.59.08s0,0,.07.1a.48.48,0,0,1,0,.21l-1,7a.52.52,0,0,1-.06.2c0,.06-.07.08-.1.08Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "226.77px 302.6px"
    },
    id: "elopeijn0hapr",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-403--inject-32",
    className: "animable",
    style: {
      transformOrigin: "163.023px 80.2952px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--404--inject-32",
    className: "animable",
    style: {
      transformOrigin: "163.023px 80.2952px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.21,105.27a1.09,1.09,0,0,0-.17-.13l-5.26-3V77.19a1.71,1.71,0,0,0-.41-1.27.64.64,0,0,0-.17-.13l-5.62-3.24a.75.75,0,0,0-.82,0L122,77.11a3.55,3.55,0,0,0-1.07.89,7.56,7.56,0,0,0-.85,1.65L104.56,118.6a10.66,10.66,0,0,0-.67,3.81v8.45a1.67,1.67,0,0,0,.42,1.27.7.7,0,0,0,.17.13l5.62,3.25a.75.75,0,0,0,.81-.06l10.67-6.16v1.63a1.69,1.69,0,0,0,.42,1.27l.16.13,5.63,3.25a.79.79,0,0,0,.82-.06l6.77-3.91a2.64,2.64,0,0,0,1-1.21,4.14,4.14,0,0,0,.41-1.75v-8.12l4.45-2.57a2.63,2.63,0,0,0,1-1.21,4,4,0,0,0,.41-1.75v-8.44A1.7,1.7,0,0,0,142.21,105.27Z",
    style: {
      fill: "current",
      transformOrigin: "123.269px 104.043px"
    },
    id: "elh4tudio98e8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6kuo09k79s3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.47,81.24l0,.1a7.51,7.51,0,0,0-.79,1.55l-15.47,39a9.49,9.49,0,0,0-.46,1.6l-5.66-3.27a10.25,10.25,0,0,1,.45-1.58L120,79.65a7.74,7.74,0,0,1,.86-1.65,0,0,0,0,1,0,0Z",
    style: {
      opacity: 0.15,
      transformOrigin: "115.28px 100.745px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluse42udspze"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110,135.47c-.63-.37-5.32-3.08-5.55-3.2l-.17-.14a1.7,1.7,0,0,1-.42-1.28v-8.43a11.37,11.37,0,0,1,.22-2.22l5.62,3.25a11.3,11.3,0,0,0-.21,2.22v8.44a1.73,1.73,0,0,0,.41,1.27Z",
    style: {
      opacity: 0.3,
      transformOrigin: "106.927px 127.835px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluem6nz6ljvm"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "127.47 98.5 127.47 113.15 122.73 110.42 127.47 98.5",
    style: {
      opacity: 0.3,
      transformOrigin: "125.1px 105.825px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7ab1n0m6e0j"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "127.47 113.15 119.92 117.51 122.73 110.42 127.47 113.15",
    style: {
      opacity: 0.4,
      transformOrigin: "123.695px 113.965px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7ozgzw69r8v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.62,135.44l.1.08-5.55-3.2a.43.43,0,0,1-.17-.13,1.67,1.67,0,0,1-.42-1.27v-1.63l5.63-3.25v8.12A1.74,1.74,0,0,0,127.62,135.44Z",
    style: {
      opacity: 0.3,
      transformOrigin: "124.646px 130.78px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnuludv1gmx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142,105.11a.78.78,0,0,0-.74.09l-4.45,2.57v-5.66Z",
    style: {
      opacity: 0.15,
      transformOrigin: "139.405px 104.94px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elts1ip08ltpd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.16,75.77a.79.79,0,0,0-.78.07l-7.81,4.51a3.76,3.76,0,0,0-1,.89L120.89,78a3.72,3.72,0,0,1,1-.88l7.82-4.51a.75.75,0,0,1,.82,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "128.525px 76.864px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.61,135.51a.77.77,0,0,1-1-.07,1.74,1.74,0,0,1-.41-1.28V126l-16.3,9.41a.74.74,0,0,1-1-.07,1.74,1.74,0,0,1-.41-1.28v-8.44a10.45,10.45,0,0,1,.67-3.81l15.47-39a7.24,7.24,0,0,1,.85-1.64,3.51,3.51,0,0,1,1.06-.89l7.81-4.51a.75.75,0,0,1,1,.07,1.71,1.71,0,0,1,.41,1.27v30.58l4.45-2.57a.76.76,0,0,1,1,.07,1.7,1.7,0,0,1,.41,1.28V115a4,4,0,0,1-.41,1.75,2.63,2.63,0,0,1-1,1.21l-4.45,2.57v8.12a4.14,4.14,0,0,1-.41,1.75,2.64,2.64,0,0,1-1,1.21Zm-1.14-22.36V98.5l-7.55,19Z",
    style: {
      fill: "current",
      transformOrigin: "126.056px 105.637px"
    },
    id: "el6f4lij0ur8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.49,70a34.85,34.85,0,0,0-1.06-7.63,11.8,11.8,0,0,0-2.74-5.31A6.76,6.76,0,0,0,176.28,56l-5.64-3.25a6.94,6.94,0,0,0-3.21-.91,12.68,12.68,0,0,0-6.67,2.1,24.42,24.42,0,0,0-6.67,5.6,32.84,32.84,0,0,0-4.63,7.38,38.69,38.69,0,0,0-2.75,8.47,55.19,55.19,0,0,0-1.06,8.85q-.1,3.5-.1,7.23c0,2.5,0,4.81.1,7a35.47,35.47,0,0,0,1.06,7.63,11.81,11.81,0,0,0,2.75,5.31,6.12,6.12,0,0,0,1.4,1.1c.94.56,5.18,3,5.72,3.31a7.11,7.11,0,0,0,3.13.86,12.68,12.68,0,0,0,6.67-2.1,24.46,24.46,0,0,0,6.68-5.6,33.57,33.57,0,0,0,4.63-7.38,38.67,38.67,0,0,0,2.74-8.47,54.08,54.08,0,0,0,1.06-8.85q.1-3.33.1-7.07T181.49,70Zm-20.44,28.3a22.2,22.2,0,0,1-.2-2.6q-.25-6.63,0-13.38a26.75,26.75,0,0,1,.36-3.88,17.86,17.86,0,0,1,.93-3.44,11.62,11.62,0,0,1,1.66-2.91,8.47,8.47,0,0,1,2.25-2q.16,1.17.24,2.58.21,6.48,0,13.38a29.35,29.35,0,0,1-.33,3.85,15.61,15.61,0,0,1-.93,3.45,11.91,11.91,0,0,1-1.69,2.92A8.75,8.75,0,0,1,161.05,98.32Z",
    style: {
      fill: "current",
      transformOrigin: "163.57px 84.26px"
    },
    id: "elc2vd748lcy4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld5g4vrbx1lr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.43,115.65c-.93-.53-4.7-2.7-5.57-3.22a6.65,6.65,0,0,1-1.4-1.1,11.81,11.81,0,0,1-2.75-5.31,35.47,35.47,0,0,1-1.06-7.63c-.06-2.14-.1-4.45-.1-7s0-4.91.1-7.23a55.06,55.06,0,0,1,1.06-8.85,38.81,38.81,0,0,1,1.75-6.06l5.62,3.25a39,39,0,0,0-1.74,6,53.12,53.12,0,0,0-1.06,8.86q-.1,3.48-.11,7.23c0,2.5,0,4.81.11,7a34.34,34.34,0,0,0,1.06,7.63,11.71,11.71,0,0,0,2.74,5.3A6.54,6.54,0,0,0,156.43,115.65Z",
    style: {
      opacity: 0.15,
      transformOrigin: "150.99px 92.45px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqxw19c0ih0q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.06,55.85a7.13,7.13,0,0,0-3-.79q-2.79-.14-6.68,2.1a24.57,24.57,0,0,0-6.67,5.61,33.21,33.21,0,0,0-4.63,7.36c-.19.41-.36.81-.53,1.23l-.47,1.19h0l-5.62-3.25c.13-.36.27-.71.41-1.06s.38-.9.59-1.35a33.3,33.3,0,0,1,4.62-7.38,24.76,24.76,0,0,1,6.68-5.6,12.59,12.59,0,0,1,6.67-2.1,6.9,6.9,0,0,1,3.21.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "162.26px 62.18px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsngejgm4hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.92,89.32a29.32,29.32,0,0,1-.34,3.86,15.52,15.52,0,0,1-.92,3.44A12,12,0,0,1,170,98l-5.62-3.25a12.61,12.61,0,0,0,.63-1.34,15.77,15.77,0,0,0,.94-3.45,29.35,29.35,0,0,0,.33-3.85q.21-6.89,0-13.38c0-.94-.13-1.8-.24-2.59l.33-.21a4.35,4.35,0,0,1,2.59-.78,2.34,2.34,0,0,1,1.66,1,6.11,6.11,0,0,1,.9,2.38,26.61,26.61,0,0,1,.39,3.45Q172.12,82.43,171.92,89.32Z",
    style: {
      opacity: 0.3,
      transformOrigin: "168.199px 83.5744px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elagy7g3znbkn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170,98a10.51,10.51,0,0,1-1,1.58,8.86,8.86,0,0,1-2.59,2.21,4.38,4.38,0,0,1-2.58.77,2.33,2.33,0,0,1-1.68-1,5.76,5.76,0,0,1-.93-2.37c-.06-.28-.1-.57-.14-.87a8.6,8.6,0,0,0,2.29-2,11.4,11.4,0,0,0,1-1.58Z",
    style: {
      opacity: 0.4,
      transformOrigin: "165.54px 98.6505px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.38,57.16q3.88-2.25,6.68-2.1a6.71,6.71,0,0,1,4.63,2,11.8,11.8,0,0,1,2.74,5.31A34.85,34.85,0,0,1,181.49,70q.1,3.36.1,7.11t-.1,7.07a54.08,54.08,0,0,1-1.06,8.85,38.67,38.67,0,0,1-2.74,8.47,33.57,33.57,0,0,1-4.63,7.38,24.46,24.46,0,0,1-6.68,5.6,12.68,12.68,0,0,1-6.67,2.1,6.68,6.68,0,0,1-4.63-2,11.71,11.71,0,0,1-2.74-5.3,34.94,34.94,0,0,1-1.06-7.63c-.07-2.14-.1-4.45-.1-7s0-4.9.1-7.23a54,54,0,0,1,1.06-8.85,38.93,38.93,0,0,1,2.74-8.48,33.5,33.5,0,0,1,4.63-7.37A24.57,24.57,0,0,1,166.38,57.16Zm5.54,32.16q.21-6.88,0-13.38a26.64,26.64,0,0,0-.39-3.44,6.17,6.17,0,0,0-.9-2.38,2.31,2.31,0,0,0-1.66-1,4.44,4.44,0,0,0-2.59.78,9,9,0,0,0-2.58,2.21A11.62,11.62,0,0,0,162.14,75a17.86,17.86,0,0,0-.93,3.44,26.75,26.75,0,0,0-.36,3.88q-.25,6.75,0,13.38a21.32,21.32,0,0,0,.34,3.46,5.52,5.52,0,0,0,.93,2.37,2.31,2.31,0,0,0,1.68,1,4.38,4.38,0,0,0,2.58-.77A9,9,0,0,0,169,99.55a11.88,11.88,0,0,0,1.68-2.92,15.76,15.76,0,0,0,.93-3.45A31.14,31.14,0,0,0,171.92,89.32Z",
    style: {
      fill: "current",
      transformOrigin: "166.385px 85.8153px"
    },
    id: "el64jtx2fx3ps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.68,56a6.27,6.27,0,0,0-1.16-.85,6.56,6.56,0,0,0-.76-.35,6,6,0,0,1,.58.25l-4.27-2.48h0l5.3-11.28c.21-.44.43-1,.66-1.57a4.82,4.82,0,0,0,.36-1.77V29.59a1.68,1.68,0,0,0-.41-1.26.91.91,0,0,0-.24-.16h0L214.25,25a.81.81,0,0,0-.79.07L189,39.14a2.31,2.31,0,0,0-.83,1,1.49,1.49,0,0,0-.14.24,4.17,4.17,0,0,0-.41,1.74V50.4a1.66,1.66,0,0,0,.41,1.25,1.46,1.46,0,0,0,.21.16c.19.09,4.54,2.62,5.41,3.12,0,0-.05,0-.06-.06h0a.75.75,0,0,0,1,.07l3.61-2.09L197,55.57a17.85,17.85,0,0,0-.71,1.67,3.17,3.17,0,0,0-.14.4c0,.13-.08.26-.11.4a.11.11,0,0,1,0,.05,1.9,1.9,0,0,0,0,.25s0,0,0,.08a3.1,3.1,0,0,0-.05.6v6.76a1.73,1.73,0,0,0,.4,1.26,1.43,1.43,0,0,0,.22.15L202,70.34l-.08-.06a.75.75,0,0,0,.94,0l4.23-2.45h0a7.94,7.94,0,0,1-1.52,3.72,12.92,12.92,0,0,1-4.06,3.6,5.83,5.83,0,0,1-3.13,1.07,5.76,5.76,0,0,1-.66-.1h0l-2.44-1.41a1,1,0,0,0-.34-.11,2,2,0,0,0-1.23.36l-6.44,3.72a2.18,2.18,0,0,0-.79,1,.49.49,0,0,0,0,.11h0a4.15,4.15,0,0,0-.22.65,2.88,2.88,0,0,0-.07.65,12.08,12.08,0,0,0,1.09,5.06,7.11,7.11,0,0,0,3,3.28c.82.46,4.08,2.38,5.34,3.09-.18-.11-.34-.24-.5-.36a6,6,0,0,0,.72.48,7.9,7.9,0,0,0,4.77.78A17.12,17.12,0,0,0,207.06,91a29.39,29.39,0,0,0,15.12-26.58C222.18,60.32,221.35,57.52,219.68,56Z",
    style: {
      fill: "current",
      transformOrigin: "204.192px 59.2179px"
    },
    id: "el9bahbz2v7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluxlyc1entf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.18,40.22a.64.64,0,0,0,0-.07l-.13.25a4,4,0,0,0-.41,1.74v8.32a1.63,1.63,0,0,0,.41,1.26.7.7,0,0,0,.2.15L193.68,55a.12.12,0,0,0-.06-.06h0a1.65,1.65,0,0,1-.41-1.26V45.34a3.87,3.87,0,0,1,.41-1.72,3,3,0,0,1,.28-.46c-.06.09-.13.17-.19.28Z",
    style: {
      opacity: 0.15,
      transformOrigin: "190.766px 47.575px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzrb4kryz8l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.46,62.06l-5.56-3.21c0,.06,0,.11,0,.17v6.76a1.73,1.73,0,0,0,.4,1.26,1.43,1.43,0,0,0,.22.15c.21.11,4.83,2.78,5.46,3.15l-.07-.07,0,0a1.65,1.65,0,0,1-.41-1.24V62.23S201.46,62.12,201.46,62.06Z",
    style: {
      opacity: 0.15,
      transformOrigin: "198.937px 64.595px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj4rgpx5fmm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.8,60.45c.24-.61.48-1.16.72-1.67l5.41-11.54-9.72,5.62L197,55.57c-.24.5-.48,1-.71,1.67a3,3,0,0,0-.14.39c0,.14-.08.26-.11.4v.06a2,2,0,0,1,0,.24.19.19,0,0,1,0,.08,2.25,2.25,0,0,0,0,.44l5.56,3.21A5.05,5.05,0,0,1,201.8,60.45Z",
    style: {
      opacity: 0.3,
      transformOrigin: "201.98px 54.65px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljv0wyweng8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.45,79.66s0,.07,0,.11h0a3.41,3.41,0,0,0-.22.66,3,3,0,0,0-.08.64,12.13,12.13,0,0,0,1.1,5.07,7,7,0,0,0,3,3.27l5.33,3.1a.45.45,0,0,1-.1-.09,7.07,7.07,0,0,1-2.66-3.06,12,12,0,0,1-1.1-5.07,3.33,3.33,0,0,1,.33-1.41,3,3,0,0,1,.27-.44l-5.57-3.2A2.77,2.77,0,0,0,186.45,79.66Z",
    style: {
      opacity: 0.15,
      transformOrigin: "190.865px 85.875px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el75yo45o65yq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.71,76.16h0l-2.44-1.42a1.13,1.13,0,0,0-.34-.1,2.08,2.08,0,0,0-1.23.35l-6.44,3.73a1.76,1.76,0,0,0-.52.53l5.57,3.2a1.9,1.9,0,0,1,.53-.53l6.43-3.71c.71-.41,1.26-.48,1.63-.19l-3.17-1.85Z",
    style: {
      opacity: 0.3,
      transformOrigin: "193.82px 78.5444px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elb0f7g7z0qt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.92,79.47a5.75,5.75,0,0,0,3.15-1.07,12.88,12.88,0,0,0,4.05-3.6,8.13,8.13,0,0,0,1.62-4.94c0-1.82-.55-2.86-1.62-3.08a6,6,0,0,0-4.05,1.1,7.85,7.85,0,0,1-1.52,3.71,12.88,12.88,0,0,1-4.05,3.6,5.71,5.71,0,0,1-3.14,1.06,4.25,4.25,0,0,1-.65-.09L200.88,78l1.26.89A3.75,3.75,0,0,0,203.92,79.47Z",
    style: {
      opacity: 0.4,
      transformOrigin: "205.225px 73.1123px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvbp8ipbnjj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.07,52.55s3.08,1.8,4.27,2.48a.46.46,0,0,0-.14-.05.34.34,0,0,0-.15-.07,7.72,7.72,0,0,0-4.86-.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "215.765px 53.79px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el40decbndimm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.76,26.52l-2.52-1.47a.81.81,0,0,0-.79.07L189,39.21a2.36,2.36,0,0,0-.84.94.64.64,0,0,1,0,.07l5.55,3.22c.06-.11.13-.19.19-.28a3,3,0,0,1,.19-.3,1.79,1.79,0,0,1,.49-.43L219,28.34a.82.82,0,0,1,.71-.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "203.935px 34.2093px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219,28.26a.75.75,0,0,1,1,.07,1.68,1.68,0,0,1,.41,1.26v8.34A4.82,4.82,0,0,1,220,39.7c-.23.61-.45,1.13-.66,1.57l-5.3,11.28-.88,1.88a7.58,7.58,0,0,1,5.33.71,6.63,6.63,0,0,1,1.16.85c1.67,1.53,2.5,4.33,2.5,8.42A29.39,29.39,0,0,1,207.06,91a17.12,17.12,0,0,1-6.51,2.42,7.9,7.9,0,0,1-4.77-.78,7.12,7.12,0,0,1-3-3.27,12.2,12.2,0,0,1-1.1-5.07,3.3,3.3,0,0,1,.33-1.41,2.07,2.07,0,0,1,.8-1l6.43-3.72c.72-.41,1.26-.48,1.64-.2s.79.58,1.25.89a3.68,3.68,0,0,0,1.78.58,5.86,5.86,0,0,0,3.14-1.06,13.09,13.09,0,0,0,4.06-3.61,8,8,0,0,0,1.61-4.93c0-1.84-.53-2.86-1.61-3.08a6.09,6.09,0,0,0-4.06,1.08l-4.23,2.45a.75.75,0,0,1-1-.07,1.69,1.69,0,0,1-.4-1.26V62.23a5,5,0,0,1,.35-1.78c.24-.61.48-1.16.72-1.67l5.41-11.54-13.33,7.7a.75.75,0,0,1-1-.07,1.69,1.69,0,0,1-.41-1.26V45.28a4.06,4.06,0,0,1,.41-1.73,2.61,2.61,0,0,1,1-1.19Z",
    style: {
      fill: "current",
      transformOrigin: "206.922px 60.8044px"
    },
    id: "elf5u3728jt1",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-32",
    className: "animable",
    style: {
      transformOrigin: "372.703px 274.847px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-32",
    className: "animable",
    style: {
      transformOrigin: "372.703px 274.847px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.41,218.19l7.08-.31,4.58,8.68s-2.85,1.48-13.05,1.6Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "419.545px 223.02px"
    },
    id: "el9avoy1vdo3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.6,197.3c2.7,1.27,4.17,2.74,7.07,5.1,3.58,2.92,15.93,11.31,18.58,12a170.44,170.44,0,0,0,21.36,3.44s-1.15,7,.34,10.45c-6.34.28-22.5.82-28.14-.51-6-1.42-12.66-4.8-17.78-7.77S367.05,199.82,369.6,197.3Z",
    style: {
      fill: "current",
      transformOrigin: "392.194px 212.969px"
    },
    id: "elfc5vyt752mo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli2wm6ns2w4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "392.194px 212.969px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.6,197.3c2.7,1.27,4.17,2.74,7.07,5.1,3.58,2.92,15.93,11.31,18.58,12a170.44,170.44,0,0,0,21.36,3.44s-1.15,7,.34,10.45c-6.34.28-22.5.82-28.14-.51-6-1.42-12.66-4.8-17.78-7.77S367.05,199.82,369.6,197.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "392.194px 212.969px"
    },
    id: "el29sr5yrqmd7",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el0xwh2mdisowi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371,220.06c5.12,3,11.74,6.35,17.78,7.77,4.08,1,13.68.95,21.08.76a118.81,118.81,0,0,1-19-3.06,73.51,73.51,0,0,1-11.77-6.2c-3.33-2.37-3.53-6.62-5.23-12.77-2.26-8.16-4.25-9.26-4.25-9.26C367.05,199.82,365.92,217.09,371,220.06Z",
    style: {
      opacity: 0.1,
      transformOrigin: "388.65px 213px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.89,228.59a14.48,14.48,0,0,1,.31-8.69s-2.06,2-1.62,8.72Z",
    style: {
      fill: "current",
      transformOrigin: "409.359px 224.26px"
    },
    id: "elll2gz4jsftj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el11t7zmqk2n4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.89,228.59a14.48,14.48,0,0,1,.31-8.69s-2.06,2-1.62,8.72Z",
    style: {
      opacity: 0.1,
      transformOrigin: "409.359px 224.26px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.39,226.71c6-.21,8.23-3.25,9.07-8.52s.69-12.16.76-14-.47-2.46-1.2-2.56c-.27,0-1.43.25-1.56,2.2-.24,3.56-.33,5.75-1,5.72s-.57-2.66-.51-6.25c0-2.42,0-4.46-1.4-4.46s-1.79,1.44-1.86,4.71,0,5.7-.86,5.77c-.7,0-.56-3.43-.72-5.67s-.15-3.58-1.55-3.55-1.61,1.83-1.56,4a86.09,86.09,0,0,1-.23,9c-.39,1.29-1.73-1.89-2.71-3.2-1.61-2.15-3.58-1.17-2.78.79a38.83,38.83,0,0,1,2.18,7.4C418.88,220.58,419.89,226.73,424.39,226.71Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "425.161px 212.775px"
    },
    id: "elceajpparnqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.36,215.82s3.62,3.77,2.32,7.8a5.35,5.35,0,0,0,.65-5.4A4.09,4.09,0,0,0,424.36,215.82Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "426.07px 219.72px"
    },
    id: "el2pa297odlxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39,404.83c-.13,1.14-.28,4.34-6.07,5.13s-9.44-1.12-11-3.9-1.19-5.06-1.44-7.64-2.37-3.95-3-5.28c-.9-1.95.42-5,.42-5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.478px 399.14px"
    },
    id: "elx2k6lnhv56s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.63,395.77a3.49,3.49,0,0,1-.38,2.8,12.16,12.16,0,0,1-9.28,2.48,22.39,22.39,0,0,1-9.81-3.85,12.92,12.92,0,0,0-7.58-2.18c-2.79-.1-4.82-.72-5-1.45-.37-1.28-.37-2.1.23-2.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.547px 396.343px"
    },
    id: "elmzvqt5lizi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,402.2a31.89,31.89,0,0,0-2.66-3.17,28.64,28.64,0,0,1-6-15.36c0-.31-.06-.91-.37-1.1s-.63.08-1,.22h0v0a6,6,0,0,1-1.79.47,33.38,33.38,0,0,1-4.83-.19c-.4.05-.52,1.29-.49,2.62-.73-.46-1-1.38-1.62-1.91-.36-.29-.51-.3-.51-.77,0-.31,0-.59,0-.9-.52-.15-1,1.87-1.4,3.41-.5,1.78-1.12,3.79-.42,5.6a15.72,15.72,0,0,0,1.63,2.8,11.62,11.62,0,0,1,2.1,5.12c.08.81,0,1.64.13,2.45a7.16,7.16,0,0,0,5.06,5.87c3.52,1.11,8.82.93,11.93-1.53C345.85,405,345.48,403.15,345,402.2Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "334.533px 395.057px"
    },
    id: "elkew2zbqq8vm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.29,392c-.77-.24-1.53-.52-2.28-.82a41.85,41.85,0,0,1-6.07-3c-.85-.52-1.69-1.06-2.51-1.63s-1.65-1.27-2.47-1.93a8.81,8.81,0,0,1-1.18-1.26,13,13,0,0,1-1.74-2.82,1,1,0,0,0-.43-.57.84.84,0,0,0-.82.17,4,4,0,0,1-.64.43l-.68.28a7.85,7.85,0,0,1-2.28.56c-2.94.26-3-.33-3.16.62a7.93,7.93,0,0,0,0,1.06c-1.55-.25-2.77-.76-2.84-1.34l-.18-1.88c-2.31-.32-2.08,2.38-2.36,5.34-.23,2.54-.82,4.73-.12,6.58,2.33,2,6.46,1.54,8.81,1.93,3.32.55,4.88,3,9.5,4.61,7.44,2.58,12.15-.4,13.54-1.69C388.28,395,388.46,393.05,385.29,392Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "371.574px 389.596px"
    },
    id: "elt9jv6m5yq2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.2,250.14c-.93,9-1.91,22.55-2.29,33.12-.7,19.86-.43,44.69-.43,44.69a68.59,68.59,0,0,0-2.14,12.73c-.47,12.69-.38,44.1-.38,44.1s5.26,5.3,13.13,1.14c0,0,7-42.87,8.92-55.38,1.87-11.93,5.5-38,5.5-38l1.64,36.05a52.37,52.37,0,0,0-1.23,16.26c.42,5.81,3.74,37.44,3.74,37.44,3,2.84,11.84,1.3,13.77-1,0,0,3.09-45.34,3.43-51.47.74-13.26,1-63.83,0-71.5S329.2,250.14,329.2,250.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.735px 318.827px"
    },
    id: "elz7byubibv4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.51,292.56l2.31-15.29a30.68,30.68,0,0,0,11-4.64s-1.8,4.08-8.82,7l-2.28,14.23-.55,34.75Z",
    id: "elzdep52ncspr",
    className: "animable",
    style: {
      transformOrigin: "358.165px 300.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,155.33s-.21,0-.54.11a2.48,2.48,0,0,0-1.33-2.8,2.67,2.67,0,0,0-3.45,1.41l3.76,1.73a5.24,5.24,0,0,0-2.86,2.44c-1,2.12.33,6.64,1.7,12.22a79,79,0,0,0,3,10.34c.63,1.63,1.77,1.68,1.77,1.68v-5.57l-.24-4.61s3-4.05,3.29-7.37c.41-4.26-.48-6-.48-6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "339.944px 167.452px"
    },
    id: "el0gzbto0iec2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,171.54c-1.11,1-2-1.53-2.95-2.51s-4-2.3-5.5.91,1.39,7.71,3.68,8.77c3.34,1.55,4.84-1.82,4.84-1.82v13.93c3.52,6.35,11.29,6.14,14.89,7a12.33,12.33,0,0,0-.14-6.25l0-4.54a16.7,16.7,0,0,0,4.6.25c3-.48,4.67-3,5.58-6.28,1.47-5.29,1.77-14.18-.27-24.45-3.4-2.63-14.92-2.21-22.06,2.32C345.19,168,343.14,170.57,342,171.54Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "350.659px 176.373px"
    },
    id: "elinbis8xsov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.82,187.06s-6.79-1.34-9.17-2.6a7.88,7.88,0,0,1-3.29-3.23,10.64,10.64,0,0,0,1.88,3.82c1.74,2.21,10.59,3.82,10.59,3.82Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "350.595px 185.05px"
    },
    id: "elwe5q30v9bf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.73,169.64a1.45,1.45,0,1,1-1.45-1.45A1.45,1.45,0,0,1,353.73,169.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.28px 169.64px"
    },
    id: "eljz0akv7bwj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.24,168.58a1.45,1.45,0,1,1-1.45-1.45A1.45,1.45,0,0,1,365.24,168.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.79px 168.58px"
    },
    id: "el2dnppciadih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.77,165.78l-3,1.59a1.79,1.79,0,0,1,.75-2.37A1.67,1.67,0,0,1,351.77,165.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "350.177px 166.098px"
    },
    id: "el4dqivb5gzv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.48,178.6l5.09,1.32a2.57,2.57,0,0,1-3.15,2A2.75,2.75,0,0,1,354.48,178.6Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "356.984px 180.299px"
    },
    id: "elfrvx7259ak6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,179.67a3.05,3.05,0,0,0-.52.05,2.73,2.73,0,0,0,2,2.17,2.41,2.41,0,0,0,1.28,0A2.77,2.77,0,0,0,355,179.67Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "356.12px 180.823px"
    },
    id: "elo5pkmtsewv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.44,166.06l-3.12-1.48a1.66,1.66,0,0,1,2.25-.86A1.82,1.82,0,0,1,366.44,166.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.952px 164.809px"
    },
    id: "el8xvwadsfo5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.23 167.93 359.14 177.24 363.79 175.15 358.23 167.93",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "361.01px 172.585px"
    },
    id: "elaz1of66qjy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.08,190.82c-6.18,2.21-10.77,4.37-15.06,8.05,0,0,4.44,19.27,7.22,29.88,2.52,9.67.16,29.37.16,29.37s3.89,5.88,26,5.24C366.9,263,373,259,373,259s1.06-21.73.58-39.9c-.38-14.62-1.44-18.15-3.93-21.81-1.8-1.22-11.75-4.9-11.75-4.9a26.09,26.09,0,0,0-.86,5.45C353.36,192.18,336.08,190.82,336.08,190.82Z",
    style: {
      fill: "current",
      transformOrigin: "347.362px 227.114px"
    },
    id: "elicogq2bvqfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellfgnc21knw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.08,190.82c-6.18,2.21-10.77,4.37-15.06,8.05,0,0,4.44,19.27,7.22,29.88,2.52,9.67.16,29.37.16,29.37s3.89,5.88,26,5.24C366.9,263,373,259,373,259s1.06-21.73.58-39.9c-.38-14.62-1.44-18.15-3.93-21.81-1.8-1.22-11.75-4.9-11.75-4.9a26.09,26.09,0,0,0-.86,5.45C353.36,192.18,336.08,190.82,336.08,190.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "347.362px 227.114px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6nnvrj4ej1e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.15,240.67c-.26-6.51-1.67-18.85-1.57-28.2l-4.41-6.69-2.57,8.31c1.23,5.1,2.56,10.54,3.64,14.66,2.52,9.67.16,29.37.16,29.37s3.89,5.88,26,5.24l.4,0A37.07,37.07,0,0,1,342.93,260C336.06,256.6,333.41,247.19,333.15,240.67Z",
    style: {
      opacity: 0.1,
      transformOrigin: "339.7px 234.594px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.1,184.93V186c.2,1,2.25,3.45,7.41,5.77a17.37,17.37,0,0,1,7.48,6.06s-1.76-2.71-3.93-1.28-4.37,5-5.49,5-4.86-3.57-7.79-6.63c-2.45-2.58-3.7-4.13-3.7-4.13S340.09,185,342.1,184.93Z",
    style: {
      fill: "current",
      transformOrigin: "346.535px 193.24px"
    },
    id: "eldo1klnflxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,197.85c1.57-3.76,4.4-.55,4.58-.53.82.05-1.79-6.86-4.73-8.76v3Z",
    style: {
      fill: "current",
      transformOrigin: "359.291px 193.205px"
    },
    id: "el6ji2456pf5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt8yz23wgtk9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.1,184.93V186c.2,1,2.25,3.45,7.41,5.77a17.37,17.37,0,0,1,7.48,6.06s-1.76-2.71-3.93-1.28-4.37,5-5.49,5-4.86-3.57-7.79-6.63c-2.45-2.58-3.7-4.13-3.7-4.13S340.09,185,342.1,184.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "346.535px 193.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj9wzsrkdg9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357,197.85c1.57-3.76,4.4-.55,4.58-.53.82.05-1.79-6.86-4.73-8.76v3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "359.291px 193.205px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.11,262.77c.26-13.86.62-49.46-4.12-64.92,0,0,4.47,32.91,2.05,65.19Q360.12,262.92,361.11,262.77Z",
    style: {
      fill: "current",
      transformOrigin: "359.116px 230.445px"
    },
    id: "elsrkm17ypwg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhsvyulzv7f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.11,262.77c.26-13.86.62-49.46-4.12-64.92,0,0,4.47,32.91,2.05,65.19Q360.12,262.92,361.11,262.77Z",
    style: {
      opacity: 0.1,
      transformOrigin: "359.116px 230.445px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,214.48a38.54,38.54,0,0,0,14.09-1.7l.22,2.72a35,35,0,0,1-14,1.46Z",
    style: {
      fill: "current",
      transformOrigin: "345.715px 214.955px"
    },
    id: "elwhqrpp935j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el538cs7op8wx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.56,214.48a38.54,38.54,0,0,0,14.09-1.7l.22,2.72a35,35,0,0,1-14,1.46Z",
    style: {
      opacity: 0.1,
      transformOrigin: "345.715px 214.955px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-32",
    className: "animable",
    style: {
      transformOrigin: "368.423px 214.581px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.17,208.11a.2.2,0,0,0-.07-.2h0c-.05,0-.38-.23-.43-.26h0c-.05,0-.12,0-.22.06a3.15,3.15,0,0,1-3.12.34,2.24,2.24,0,0,1-.35-.34v0h0a.32.32,0,0,0-.09-.08l-.44-.27h0c-.1-.05-.2,0-.27.14-.93,2.11-2.84,4.22-4.08,4.72a.7.7,0,0,0-.25.17.53.53,0,0,0-.15.35c-.09,2.75,1.27,7.19,4.07,8.76a5.58,5.58,0,0,0,.52.32C372.32,217.85,373.06,211.37,373.17,208.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "368.435px 214.581px"
    },
    id: "elc89xa3i7ti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.74,221.45c-2.8-1.57-4.16-6-4.07-8.76a.55.55,0,0,1,.06-.22l.43.28a.46.46,0,0,0-.05.21C364,215.56,365.23,219.68,367.74,221.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "365.703px 216.96px"
    },
    id: "el5lc1rgx3kxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.17,208.11c-.11,3.26-.85,9.74-4.91,13.66-2.86-1.53-4.24-6-4.15-8.81a.53.53,0,0,1,.15-.35.74.74,0,0,1,.25-.17c1.24-.5,3.15-2.61,4.08-4.72.07-.15.16-.19.26-.14h0a.32.32,0,0,1,.09.08h0v0a3,3,0,0,0,3.91.28.25.25,0,0,1,.22-.07h0A.2.2,0,0,1,373.17,208.11Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "368.643px 214.665px"
    },
    id: "eli2byeb0n07p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.85,207.58c-.1-.05-.19,0-.26.14-.93,2.11-2.84,4.22-4.08,4.72a.74.74,0,0,0-.25.17.53.53,0,0,0-.15.35c-.09,2.77,1.29,7.28,4.15,8.81A30.26,30.26,0,0,0,368.85,207.58Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "366.766px 214.666px"
    },
    id: "eliwdwysxknop",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,160.89s9.32,4.54,19.32.61c10.27-4.05,1.27-6.92,1.27-6.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "358.689px 158.841px"
    },
    id: "eltxl9pjw2o78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.42,141c-7.75-1.72-16.22-2.63-26.39,1.54s-12.73,10.4-12.73,10.4,9.86,3.38,18.19,1.55S367.42,141,367.42,141Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "347.86px 147.294px"
    },
    id: "eldqocq0ehr6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.13,158.62s-5.45-4.43-5.83-5.73a34.25,34.25,0,0,0,11.82-1.45c6.68-2,13.93-8.7,21.41-10.25s10.4,2,10.4,2a35.42,35.42,0,0,1-4.74,8.65s-2.61,5.09-11.41,6.75S334.13,158.62,334.13,158.62Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "350.115px 150.067px"
    },
    id: "elajiscvg6v1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.13,158.62a14.94,14.94,0,0,0,.42,1.74,8.37,8.37,0,0,0,.81,1.47c3.12.61,10.62,1.1,20.51-1.26,6.2-1.49,9.06-3.21,10.24-4.45a3.36,3.36,0,0,0,1.2-2.9l-.12-1.37s-2.06,2.73-12.2,5.26A70.36,70.36,0,0,1,334.13,158.62Z",
    style: {
      fill: "current",
      transformOrigin: "350.727px 157.092px"
    },
    id: "el6qfhcyy9s5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el747629sbali"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.13,158.62a14.94,14.94,0,0,0,.42,1.74,8.37,8.37,0,0,0,.81,1.47c3.12.61,10.62,1.1,20.51-1.26,6.2-1.49,9.06-3.21,10.24-4.45a3.36,3.36,0,0,0,1.2-2.9l-.12-1.37s-2.06,2.73-12.2,5.26A70.36,70.36,0,0,1,334.13,158.62Z",
    style: {
      opacity: 0.05,
      transformOrigin: "350.727px 157.092px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.53,295.16c-1-1.46-3.31-2.78-4.17-3.64-1.52-1.54-3.74-4.79-3.41-5.39s1.26.18,3.2.17c3,0,3.82-1.18,3.79-2.28,0-.86-1.83-.7-4-1.18-1.91-.61-4.2-2.76-5.45-4.45s-2.26-6.1-2.26-6.1-6.49.09-11,3.16c0,0,1.29,6.7,2.77,11.45,1.65,5.33,5.39,11.21,11.08,12.53a13.83,13.83,0,0,0,7.16-.36,5.29,5.29,0,0,0,1.9-.94A2,2,0,0,0,339.53,295.16Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "328.125px 286.015px"
    },
    id: "el6hmdqc6272a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,198.87s-1-.2-2.68,3.66a61.94,61.94,0,0,0-3.27,11.53c-.67,3.22-3.87,20.13-3.87,27.4s2.17,21.88,5,34.33c3.48.35,9.46-.55,11.46-2.83-1.31-12.42-2.41-18.81-2.11-28.58,2-14.5,7.87-29.69,8.12-31.38C334.18,209.29,328.32,197.63,321,198.87Z",
    style: {
      fill: "current",
      transformOrigin: "322.432px 237.321px"
    },
    id: "el57w6p0uw1ad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxgs88wq6cq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321,198.87s-1-.2-2.68,3.66a61.94,61.94,0,0,0-3.27,11.53c-.67,3.22-3.87,20.13-3.87,27.4s2.17,21.88,5,34.33c3.48.35,9.46-.55,11.46-2.83-1.31-12.42-2.41-18.81-2.11-28.58,2-14.5,7.87-29.69,8.12-31.38C334.18,209.29,328.32,197.63,321,198.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.65,
      transformOrigin: "322.432px 237.321px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el965bw78gict"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.27,260c-1.74-8.5-4.59-25.14-2.64-38.23-1.12,6.43-2.43,15-2.43,19.69,0,7.27,2.17,21.88,5,34.33a20.33,20.33,0,0,0,4.16-.08C319.11,271.6,317.34,265.24,316.27,260Z",
    style: {
      opacity: 0.1,
      transformOrigin: "315.78px 248.815px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.94,269.69c2.84.18,7.89-.62,10-2,0,0-3.68,1.63-10.19.7Z",
    style: {
      fill: "current",
      transformOrigin: "319.845px 268.703px"
    },
    id: "elxfiu2pfxq0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvjfd58ofd6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.94,269.69c2.84.18,7.89-.62,10-2,0,0-3.68,1.63-10.19.7Z",
    style: {
      opacity: 0.1,
      transformOrigin: "319.845px 268.703px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shield--inject-32",
    className: "animable",
    style: {
      transformOrigin: "361.261px 150.42px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.79,145.63c0-.08,0-.13,0-.15h0l-.32-.2h0s-.1,0-.17,0a2.37,2.37,0,0,1-2.33.25,1.6,1.6,0,0,1-.26-.26h0a.19.19,0,0,0-.07-.06l-.32-.2h0c-.07,0-.14,0-.19.11a7.61,7.61,0,0,1-3.05,3.52.5.5,0,0,0-.19.13.41.41,0,0,0-.11.26c-.07,2,.95,5.37,3,6.54a3,3,0,0,0,.38.24C364.16,152.9,364.71,148.07,364.79,145.63Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "361.283px 150.41px"
    },
    id: "elxshjrt67z0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.74,155.59c-2.1-1.17-3.11-4.49-3-6.54a.42.42,0,0,1,0-.16l.33.2a.29.29,0,0,0,0,.16C358,151.19,358.86,154.27,360.74,155.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "359.236px 152.24px"
    },
    id: "el0ynxadbb3r1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.79,145.63c-.08,2.44-.63,7.27-3.67,10.2-2.13-1.14-3.16-4.51-3.09-6.58a.36.36,0,0,1,.11-.26.59.59,0,0,1,.18-.13,7.5,7.5,0,0,0,3.05-3.52c.05-.11.13-.15.2-.11h0a.19.19,0,0,1,.07.06h0a2.19,2.19,0,0,0,2.92.21c.07-.05.12-.06.16,0h0S364.8,145.55,364.79,145.63Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "361.409px 150.522px"
    },
    id: "elwh2av7fhc4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.57,145.23c-.07,0-.15,0-.2.11a7.5,7.5,0,0,1-3.05,3.52.59.59,0,0,0-.18.13.36.36,0,0,0-.11.26c-.07,2.07,1,5.44,3.09,6.58A22.54,22.54,0,0,0,361.57,145.23Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "360.012px 150.53px"
    },
    id: "el2ziyrlbehhd",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-32",
    className: "animable",
    style: {
      transformOrigin: "341.81px 91.87px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-32",
    className: "animable",
    style: {
      transformOrigin: "341.81px 91.87px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-32",
    className: "animable",
    style: {
      transformOrigin: "341.81px 91.87px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.86,130l-5.46-12.44,4.39-12.67V97.08l-13.44,7.76v7.76l5.78,12.18a.87.87,0,0,0,.39.35h0Z",
    style: {
      fill: "current",
      transformOrigin: "342.605px 113.54px"
    },
    id: "eluc9beweh9fo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm0lo8qi6jur"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.86,130l-5.46-12.44,4.39-12.67V97.08l-13.44,7.76v7.76l5.78,12.18a.87.87,0,0,0,.39.35h0Z",
    style: {
      opacity: 0.2,
      transformOrigin: "342.605px 113.54px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.07,55.14a8.93,8.93,0,0,0-4-7l-3.28-1.89a8.88,8.88,0,0,0-8.06,0L297.61,90.86a8.9,8.9,0,0,0-4,7V128.6a8.93,8.93,0,0,0,4,7l3.28,1.89a8.88,8.88,0,0,0,8.06,0l34.84-20,5.77,12.17a.86.86,0,0,0,1.55-.15l6.1-19.77L386,92.88a8.91,8.91,0,0,0,4-7Z",
    style: {
      fill: "current",
      transformOrigin: "341.84px 91.87px"
    },
    id: "el1cr8irfkeqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el67evii5jb2l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.58,128.6a8.93,8.93,0,0,0,4,7l3.28,1.89a9,9,0,0,0,7.37.33c-1.89.71-3.34-.36-3.34-2.65V104.38a8.2,8.2,0,0,1,1.18-4l-11.34-6.55a8.26,8.26,0,0,0-1.18,4Z",
    style: {
      opacity: 0.2,
      transformOrigin: "300.89px 116.142px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eln08wksdla69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.94,54c-.47-1.71-2-2.25-3.89-1.18L309,97.41a7.84,7.84,0,0,0-2.84,3l-11.33-6.54a8,8,0,0,1,2.83-3l77.08-44.6a9,9,0,0,1,8.07,0l3.29,1.9A8.93,8.93,0,0,1,389.94,54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "342.385px 72.8624px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M310.48,123.13V106.88a2.14,2.14,0,0,1,.15-.88,1.11,1.11,0,0,1,.47-.51l4.61-2.67c.17-.09.29-.06.37.1a2.33,2.33,0,0,1,.12.91v.8a3.6,3.6,0,0,1-.12,1.05.84.84,0,0,1-.37.52l-2.61,1.51v3.77l2.46-1.42c.17-.1.29-.07.37.09a2.44,2.44,0,0,1,.11.92v.8a3.74,3.74,0,0,1-.11,1,.87.87,0,0,1-.37.52l-2.46,1.42v6.76a1.64,1.64,0,0,1-1,1.39l-.67.38C310.81,123.77,310.48,123.68,310.48,123.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "313.342px 113.19px"
    },
    id: "eldyzytzqf82v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.25,111q0-9.22,4.39-11.77,2.14-1.23,3.26.37c.74,1.06,1.12,3.18,1.12,6.34a21.71,21.71,0,0,1-1.12,7.64,7.75,7.75,0,0,1-3.26,4.13Q317.26,120.21,317.25,111Zm5.38,2.24a6.69,6.69,0,0,0,.55-2.11,27.55,27.55,0,0,0,.19-3.66,22.45,22.45,0,0,0-.19-3.41,2.52,2.52,0,0,0-.55-1.48c-.25-.2-.57-.18-1,0a2.53,2.53,0,0,0-1,1.08,7,7,0,0,0-.57,2.12,27.42,27.42,0,0,0-.19,3.64,22.69,22.69,0,0,0,.19,3.42,2.51,2.51,0,0,0,.57,1.48.83.83,0,0,0,1,0A2.63,2.63,0,0,0,322.63,113.2Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "321.641px 108.47px"
    },
    id: "elo15rb83n6mr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.56,113.27V97a2,2,0,0,1,.16-.88,1.11,1.11,0,0,1,.51-.54L331,94a2.29,2.29,0,0,1,2.48-.26c.63.43.94,1.55.94,3.37a9,9,0,0,1-1.59,5.28v.11a1.13,1.13,0,0,1,.67.64,4.44,4.44,0,0,1,.45,1.29l1,4.38.05.28c0,.46-.34.89-1,1.29l-.58.34c-.59.34-.93.31-1-.11l-.89-4.39a1.08,1.08,0,0,0-.34-.6c-.13-.08-.33,0-.61.12l-.4.23v5.83a1.67,1.67,0,0,1-1,1.41l-.57.33C327.89,113.9,327.56,113.82,327.56,113.27Zm3.52-11.63a1.69,1.69,0,0,0,.62-.93,5.19,5.19,0,0,0,.26-1.8,2.64,2.64,0,0,0-.26-1.44.47.47,0,0,0-.68-.11l-.88.51v4.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "331.279px 103.625px"
    },
    id: "el089lftyaeqqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,108.72a1.09,1.09,0,0,1-.15-.7V92a2.09,2.09,0,0,1,.15-.85,1.11,1.11,0,0,1,.47-.51l3-1.73c2.35-1.36,3.52-.58,3.52,2.32a8.92,8.92,0,0,1-1.51,5.13l0,.09a1.28,1.28,0,0,1,1.34.73,5,5,0,0,1,.49,2.48,9.46,9.46,0,0,1-1,4.24,7,7,0,0,1-2.84,3l-3.05,1.77C336.61,108.82,336.45,108.82,336.35,108.72Zm3.49-12.47a1.85,1.85,0,0,0,.79-1,5.05,5.05,0,0,0,.26-1.82,2.79,2.79,0,0,0-.24-1.44q-.24-.34-.78,0l-1.19.69v4.25Zm.12,7.51a2.12,2.12,0,0,0,.91-1.06,5.23,5.23,0,0,0,.29-2,2.65,2.65,0,0,0-.28-1.52c-.19-.23-.5-.22-.92,0l-1.28.73v4.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "339.93px 98.5254px"
    },
    id: "elh798jqlcd2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.15,103.11V86.6a1.62,1.62,0,0,1,1-1.41l.71-.41c.63-.37.95-.26.95.3v16.51a1.63,1.63,0,0,1-.95,1.41l-.71.4C345.47,103.78,345.15,103.68,345.15,103.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "346.48px 94.0953px"
    },
    id: "eliulb45o0ds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.78,101a1,1,0,0,1-.16-.7v-16a2,2,0,0,1,.16-.88,1,1,0,0,1,.46-.51l3.19-1.84q2.18-1.26,3.21.39c.68,1.1,1,3.17,1,6.19a22.19,22.19,0,0,1-1,7.38,7.47,7.47,0,0,1-3.21,4.1l-3.19,1.83C350,101.07,349.87,101.08,349.78,101Zm3.56-5.19a3.08,3.08,0,0,0,1.28-2,20.41,20.41,0,0,0,.38-4.59,14.66,14.66,0,0,0-.38-4.15c-.26-.7-.68-.89-1.28-.54l-1.07.61V96.4Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "353.631px 90.7885px"
    },
    id: "ellbp2ujgfdlq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,95.39a1.11,1.11,0,0,1-.15-.7v-16a2.14,2.14,0,0,1,.15-.88,1.11,1.11,0,0,1,.47-.51l3.19-1.84q2.17-1.26,3.2.39t1,6.19a22,22,0,0,1-1,7.38,7.41,7.41,0,0,1-3.2,4.1l-3.19,1.83C359.7,95.48,359.54,95.49,359.44,95.39Zm3.57-5.2a3.07,3.07,0,0,0,1.28-2,20.48,20.48,0,0,0,.38-4.59,14.66,14.66,0,0,0-.38-4.15c-.26-.71-.69-.89-1.28-.55l-1.07.62v11.3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "363.298px 85.1859px"
    },
    id: "ellpv6sa10zl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,89.81a1.11,1.11,0,0,1-.15-.7v-16a2.12,2.12,0,0,1,.15-.87,1.18,1.18,0,0,1,.47-.52l4.94-2.85a.23.23,0,0,1,.37.09,2.39,2.39,0,0,1,.12.92v.8a3.64,3.64,0,0,1-.12,1,.87.87,0,0,1-.37.52L371.57,74v3.74l2.62-1.51c.17-.09.29-.06.37.1a2.3,2.3,0,0,1,.12.91V78a3.6,3.6,0,0,1-.12,1.05.84.84,0,0,1-.37.52l-2.62,1.51v4.18l3-1.71c.17-.1.29-.07.36.1a2.63,2.63,0,0,1,.11.92v.8a4,4,0,0,1-.11,1,.82.82,0,0,1-.36.52l-5,2.86C369.37,89.9,369.21,89.91,369.11,89.81Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "371.998px 79.343px"
    },
    id: "eld47ux1j136",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.53,85V68.48a1.61,1.61,0,0,1,1-1.38l.43-.26a1,1,0,0,1,.54-.16c.13,0,.24.14.33.38l3,6.67a13.89,13.89,0,0,1,.57,1.69l.07-.1c-.09-.84-.14-1.49-.14-2V65.13a1.62,1.62,0,0,1,1-1.38l.41-.23c.64-.38,1-.29,1,.26V80.29a1.64,1.64,0,0,1-1,1.39l-.32.18a1.06,1.06,0,0,1-.56.18c-.14,0-.26-.14-.35-.38l-3.2-6.92a10.16,10.16,0,0,1-.45-1.39l-.08.12a14.88,14.88,0,0,1,.13,1.68v8.49a1.62,1.62,0,0,1-1,1.39l-.4.23C376.86,85.63,376.53,85.54,376.53,85Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "380.635px 74.3864px"
    },
    id: "elciw9m0hlhjs",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-32",
    className: "animable",
    style: {
      transformOrigin: "108.785px 359.859px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-32",
    className: "animable",
    style: {
      transformOrigin: "108.785px 359.859px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-32",
    className: "animable",
    style: {
      transformOrigin: "108.966px 399.099px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.7,425.24c8.41-8.69,13.36-44,5.15-50.91H88.08c-8.2,6.88-3.27,42.21,5.15,50.9l.23.24.29.28a8.57,8.57,0,0,0,.76.69l.2.16.63.48a10,10,0,0,0,1.09.7c6.92,4.05,18.15,4.05,25.07,0h0a10,10,0,0,0,1.09-.7c.21-.15.4-.3.6-.46l.24-.19c.27-.22.51-.44.74-.66l.33-.33Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "108.966px 402.574px"
    },
    id: "elj90ci2c3moa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.71,371.55c-9.53,5.57-9.53,14.59,0,20.15s25,5.56,34.51,0,9.53-14.58,0-20.15S101.24,366,91.71,371.55Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "108.961px 381.625px"
    },
    id: "elf2671yi4etr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnq8vj9o4zyj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "108.961px 381.625px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.71,371.55c-9.53,5.57-9.53,14.59,0,20.15s25,5.56,34.51,0,9.53-14.58,0-20.15S101.24,366,91.71,371.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "108.961px 381.625px"
    },
    id: "elqf27vyr22y",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.29,374.23c-7,4.08-7,10.71,0,14.79s18.35,4.09,25.35,0,7-10.71,0-14.79S103.29,370.14,96.29,374.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.965px 381.625px"
    },
    id: "el22611aldujv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.63,381.25c-7-4.09-18.34-4.09-25.34,0a11.69,11.69,0,0,0-4.19,3.89A11.76,11.76,0,0,0,96.29,389c7,4.09,18.35,4.09,25.34,0a11.72,11.72,0,0,0,4.2-3.88A11.65,11.65,0,0,0,121.63,381.25Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "108.965px 385.125px"
    },
    id: "elbqzj9tede5r",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-32",
    className: "animable",
    style: {
      transformOrigin: "108.785px 337.706px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.81,305.77l16.7,11.42-15.79-6a28.78,28.78,0,0,0,3.12,12.14s10.43,5.06,16.1,10.4l-13.89-4.37a15.32,15.32,0,0,0,.43,7.26c.09.32.19.65.29,1,.74,2.22,1.79,6.43,3.56,11.4h0a73.25,73.25,0,0,0,5.74,12.56,51.3,51.3,0,0,0,3.82,5.64l.26.34q3.87-2.58,8-5.05c1.6-4.1,3.37-14.06,3.69-22.14,1.21-30.93-23.23-46.89-42.31-51.47C75.59,288.91,82.57,296.5,85.81,305.77Z",
    style: {
      fill: "current",
      transformOrigin: "96.7066px 328.23px"
    },
    id: "el661fus94e1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4z3e23jtvkg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.81,305.77l16.7,11.42-15.79-6a28.78,28.78,0,0,0,3.12,12.14s10.43,5.06,16.1,10.4l-13.89-4.37a15.32,15.32,0,0,0,.43,7.26c.09.32.19.65.29,1,.74,2.22,1.79,6.43,3.56,11.4h0a73.25,73.25,0,0,0,5.74,12.56,51.3,51.3,0,0,0,3.82,5.64l.26.34q3.87-2.58,8-5.05c1.6-4.1,3.37-14.06,3.69-22.14,1.21-30.93-23.23-46.89-42.31-51.47C75.59,288.91,82.57,296.5,85.81,305.77Z",
    style: {
      opacity: 0.3,
      transformOrigin: "96.7066px 328.23px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.13,306.12a22.94,22.94,0,0,1,4.34,5.23,48.28,48.28,0,0,1,3.06,6.1,62.65,62.65,0,0,1,3.74,13.08,57.68,57.68,0,0,1-1.47,26.89h0a.44.44,0,0,0,.85.26h0a58.35,58.35,0,0,0,1.06-27.23,62.82,62.82,0,0,0-4-13.09,47.87,47.87,0,0,0-3.16-6.07A23.37,23.37,0,0,0,99.13,306.12Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "105.483px 332.057px"
    },
    id: "el4ho2j7uqsbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.52,321.57l0,0c-.38.49-6.29,5.64-15.36,21.07l-18.39,4.62,15,1.35-6.88,12-15.7,3.88,12.44,1.54s-3,12.18-11.61,17.55c-4.78,3-7.15,3.48-8.67,2.15-1.06-.94-1.52-6.71-2.58-11.84s-1.45-13.52,3-23.83a31.46,31.46,0,0,1,4.78-7.64C124.72,329,146.58,321.83,157.52,321.57Z",
    style: {
      fill: "current",
      transformOrigin: "131.3px 354.001px"
    },
    id: "elezpeyy70qvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsrc24ggi8ke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.52,321.57l0,0c-.38.49-6.29,5.64-15.36,21.07l-18.39,4.62,15,1.35-6.88,12-15.7,3.88,12.44,1.54s-3,12.18-11.61,17.55c-4.78,3-7.15,3.48-8.67,2.15-1.06-.94-1.52-6.71-2.58-11.84s-1.45-13.52,3-23.83a31.46,31.46,0,0,1,4.78-7.64C124.72,329,146.58,321.83,157.52,321.57Z",
    style: {
      opacity: 0.15,
      transformOrigin: "131.3px 354.001px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8ocuwi8y8tw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.17,355.34a0,0,0,0,0,0,0v0A48.67,48.67,0,0,0,109,368.81h0a145.8,145.8,0,0,0,.22,17.45,2.92,2.92,0,0,1-.91-.51c-1.06-.94-1.52-6.71-2.58-11.84s-1.45-13.52,3-23.83a31.46,31.46,0,0,1,4.78-7.64c11.2-13.49,33.06-20.63,44-20.89-16.68,3.39-34.29,15.26-42.7,28.59A34.19,34.19,0,0,0,112.17,355.34Z",
    style: {
      opacity: 0.1,
      transformOrigin: "131.275px 353.905px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.91,327.48c-8.17,4-15.85,9.28-21.77,16.31a43.5,43.5,0,0,0-7.21,11.67,41.81,41.81,0,0,0-3,13.34,0,0,0,0,0,.09,0,53.43,53.43,0,0,1,3.72-13,50.07,50.07,0,0,1,6.94-11.55,57.58,57.58,0,0,1,9.76-9.41,75.9,75.9,0,0,1,11.5-7.28,0,0,0,1,0,0-.08Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "124.935px 348.14px"
    },
    id: "elauen0k3cx65",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.05,333.25h0a33.68,33.68,0,0,1,4,0,64.21,64.21,0,0,1,15.67,2.9c1.89.59,3.78,1.26,5.66,2,.93.39,1.86.8,2.78,1.23a45,45,0,0,1,12.34,8.3,28.44,28.44,0,0,1,4.39,5.5c.16.26.33.52.48.78h0c.39.68.73,1.36,1.07,2A38.81,38.81,0,0,1,111,374.83c.09,4.62-1.19,10-2,10.89a2.23,2.23,0,0,1-.38.32c-1.27.91-3.39.54-7.42-1.43-8.07-3.94-11.76-14.86-11.76-14.86l10.78-2.45-14.12-2-6.17-8.54,10.34-2.47L76,352.87a209.33,209.33,0,0,0-15.88-19.6l0,0Z",
    style: {
      fill: "current",
      transformOrigin: "85.5274px 359.851px"
    },
    id: "eln87ka1d95no",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltzy28hrsj4j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1,333.22a64.21,64.21,0,0,1,15.67,2.9c1.89.59,3.78,1.26,5.66,2,.93.39,1.86.8,2.78,1.23a45,45,0,0,1,12.34,8.3,28.44,28.44,0,0,1,4.39,5.5c.16.26.33.52.48.78h0c.39.68.73,1.36,1.07,2A38.81,38.81,0,0,1,111,374.83c.09,4.62-1.19,10-2,10.89a2.23,2.23,0,0,1-.38.32,2.42,2.42,0,0,1-.85.37c.57-7.2-4-25.13-9.68-32.29-6-7.45-19.73-18-38-20.85l0,0A33,33,0,0,1,64.1,333.22Z",
    style: {
      opacity: 0.05,
      transformOrigin: "85.5484px 359.796px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.81,386.41a61.14,61.14,0,0,0-1.91-15.75A50.94,50.94,0,0,0,99.83,356a36,36,0,0,0-5.13-6.15,52.73,52.73,0,0,0-6.14-5.12,59.51,59.51,0,0,0-14.07-7.4,0,0,0,0,0-.06,0,.06.06,0,0,0,0,.06,78.8,78.8,0,0,1,13.58,8,66.22,66.22,0,0,1,6,5,35.22,35.22,0,0,1,5.15,5.9,50.3,50.3,0,0,1,6.23,14.42,61.24,61.24,0,0,1,2.25,15.64,0,0,0,0,0,0,0A0,0,0,0,0,107.81,386.41Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "91.1173px 361.87px"
    },
    id: "elnq1ajd4x7uk",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.84d941b970e80b9d285f9c4d84879860.svg";
export { ForwardRef as ReactComponent };